import { BrandDto } from "api/repositories/brand/brand.types";
import { getServiceName, getServiceNameEn } from "constants/service/service";
import { COUNTRY_CD } from "constants/country"
import { CATEGORY_ID } from "constants/brand"
import { SelectCommissionProps } from "components/selectCommission/selectCommission";
import { CampaignFormContextProps } from "pages/campaigns/campaignForm/campaignForm.context";
import { getCampaignCommissionOptions } from "api/repositories/campaign/campaign.constants";

const ko = {
  common: {
    _step: (n: any) => `${n}단계`,
    _product_qty: (n: any) => `${n}개`,
    _price: (price: any, unit:string) => `${price.toLocaleString()}${unit}`,
    _price_10000: (price: any, unit :string) => `${price}만 ${unit}`,
    _price_10000_short: (price: any, unit :string) => `${price}만${unit}`,
    _amount: (n: any) => `${n}개`,
    _price_per_1ea: (price: any, unit: string) => `1개당 ${price}${unit}`,
    _listLimit: (n: any) => `최대 ${n}건이 보여집니다.`,
    _cost: (name: any) => `${name} 비용`,
    _num_of_person: (n: any) => `${n}명`,
    _weeks_ago: (n: any) => `${n}주 전`,
    _day: (n: any) => `${n}일`,
    _times: (n: any) => `${n}회`,
    _clothes: (n: any) => `${n}벌`,
    _wear: (clothes: any) => `${clothes} 착용`,
    _age: (n: any) => `${n}세`,
    _height: (n: any) => `${n}cm`,
    _top_size: (size: any) => `상의 ${size}`,
    _bottom_size: (size: any) => `하의 ${size}`,
    _bra_size: (size: any) => `브라 ${size}`,
    _pantie_size: (size: any) => `팬티 ${size}`,
    _shoes_size: (size: any) => `신발 ${size}`,
    _text_max_length_short: (n: any) => `최대 ${n}글자`,

    oneulook_base: getServiceName(),
    oneulook_en: getServiceNameEn(),
    language: '언어',
    korea : '한국',
    japan : '일본',
    locale_korea : '한국어',
    locale_japan : '日本語',
    currencyUnitKRW: '원',
    currencyUnitJPY: '엔',
    free: '무료',
    id: "아이디",
    password: "비밀번호",
    login: "로그인",
    confirm: "확인",
    dont_show_today: "오늘 하루 안보기", 
    posting: "포스팅",
    reels: "릴스",
    report: "보고서",
    lectures: '강의실',
    influencer_page: "인플루언서",
    save: "저장",
    save2: "저장하기",
    modify: "수정",
    modify2: "수정하기",
    change: "변경",
    change2: "변경하기",
    delete: "삭제",
    delete2: "삭제하기",
    cancel: "취소",
    cancel2: "취소하기",
    add: "추가",
    add2: "추가하기",
    start_date: "시작일",
    end_date: "종료일",
    inquiry: "조회",
    button_prev_1: "이전 단계로",
    button_prev_2: "이전으로",
    button_prev_3: "뒤로가기",
    button_prev_4: "이전",
    button_next_1: "다음으로",
    button_next_2: "다음",
    pay: "결제하기",
    payment: "결제",
    paid_date: "결제날짜",
    last_paid_date: "지난 결제날짜",
    input_error_1: "입력 내용을 확인해주세요.",
    payment_history1: "결제내역",
    payment_history2: "결제 내역",
    check_payment_history: "결제내역 확인",
    select_file_plz: "업로드할 파일을 선택해주세요",
    error: "에러",
    load: "불러오기",
    loading_1: "불러오는 중입니다...",
    excel: "엑셀",
    applicants_count: "지원자 수",
    bills: "영수증",
    one_line_desc: "한 줄 설명 (선택)",
    introduce: "소개",
    guideline: "가이드라인",
    manager_page: "관리자 페이지",
    popularity: "인기",
    new: "NEW",
    logout: "로그아웃",
    manage_card: "카드관리",
    release: "해제",
    close: "닫기",
    close2: "돌아가기",
    like: "좋아요",
    followers: "팔로워",
    dibs: "찜",
    cum_sel: "누적 선정",
    instagram: "인스타그램",
    instagram_opened: "확인했어요",
    instagram_confirmed: "확인했음",
    view_on_instagram: "인스타그램에서 보기",
    view_appeal_reels: "대표 릴스 보기",
    view_models_other_posting: (category_id) => {
      switch(category_id){
      case CATEGORY_ID.BEAUTY:
      return "이 모델의 다른 릴스 보기";
      default:
      return "이 모델의 다른 포스팅 보기";
      }
    },
    view_products_other_posting: (category_id) => {
      switch(category_id){
      case CATEGORY_ID.BEAUTY:
      return "이 제품의 릴스 보기";
      default:
      return "이 제품의 다른 포스팅 보기";
      }
    },
    rent_product: "제품 대여",
    create_n_manage: "생성 및 관리",
    product_presentation: "제품 증정",
    campaign: "캠페인",
    connect_company_mall: "자사몰 연동",
    connect_n_manage: "연동 및 관리",
    invite_offline: "오프라인 초청",
    transaction_info: "전자상거래 정보",
    change_password: "비밀번호 변경",
    setting_alarm: "알림 설정",
    brand: "브랜드",
    setting_brand: "브랜드 설정",
    copy: '복사하기',
    copy_button_default_text: "복사하기",
    copy_button_completed_text: "복사완료",
    copy_result_completed_text: "복사가 완료되었습니다.",
    copy_result_failed_text: "복사가 제한되었습니다.",
    is_first_visit: "처음 오셨나요?",
    brand_info: "브랜드 정보",
    show_detail: "자세히 보기",
    show_more: "더 보기",
    used_date: "사용된 날짜",
    used_count: "사용 갯수",
    none_history: "이용내역이 없습니다",
    input_tracking_num: "운송장번호 입력",
    ignore_guideline: "가이드라인 미준수",
    ignore_posting_deadline: "포스팅기한 미준수",
    approve: "선정하기",
    decline: "탈락시키기",
    start: "시작",
    start2: "시작하기",
    expiration_date: "이용 만료일자",
    next_payment_date: "다음 결제날짜",
    payment_method: "결제수단",
    total_price: "총 금액",
    date_format: "YYYY년 MM월 DD일",
    date_format2: "YY년 MM월 DD일",
    date_format3: "M월 D일 dddd",
    date_format_month: "YYYY년 MM월",
    payment_info: "결제 정보",
    payment_card_update: "결제 카드 변경하기",
    apply: "적용",
    this_week: "이번 주",
    hide: "숨기기",
    search: "검색",
    number: "번호",
    omission: "누락",
    color: "색상",
    color_value: "색상값",
    color_name: "색상명",
    size: "사이즈",
    amount: "수량",
    input: "입력",
    select: "선택",
    gender: "성별",
    male: "남성",
    female: "여성",
    season: "계절",
    spring: "봄",
    summer: "여름",
    fall: "가을",
    winter: "겨울",
    style: "스타일",
    agreement: "동의합니다",
    done: "완료",
    send: "보내기",
    notdone: "미완료",
    product: "제품",
    sub_item: "부자재",
    image: "이미지",
    state: "상태",
    unlimited: "무제한",
    _currency: (unit) => unit,
    none: "없음",
    update: "업데이트",
    name: "이름",
    role: "직책",
    title: "제목",
    product_name: "제품명",
    age: "나이",
    height: "키",
    public: "공개",
    private: "비공개",
    photo: "사진",
    wholesale_manager: "사장님",
    mobile_left: "010",
    mobile_left_placeholder: "010",
    country_code : COUNTRY_CD.KR,
    contact_country_code : '국가코드',
    country_code_empty : '국가 코드를 선택해주세요.',
    is_requesting: '요청 중 입니다.',
    selection: '선택',
    optional: '선택',
    yes: "네",
    no: "아니오",
    recommendation: "권장",
    download: `다운로드`,
    subtitle: `자막`,
    etc: `기타`,
    deadline: `기한`,

    sort_order_applied_at: `최신지원순`,
    sort_order_commission_asc: `희망원고료 낮은순`,
    sort_order_commission_desc: `희망원고료 높은순`,

    model_support_title_1: "모델 밀어주기 취소하기",
    model_support_title_2: "모델 밀어주기",
    model_support_text_1: "모델 밀어주기를 취소하시겠습니까?",
    model_support_text_2: "우리 브랜드 옷을 더 입도록 밀어줍니다.",
    model_reject_title_1: "모델 제외하기 취소하기",
    model_reject_title_2: "모델 제외하기",
    model_reject_text_1: "모델 제외하기를 취소하시겠습니까?",
    model_reject_text_2: "우리 브랜드 옷을 참여할 수 없도록 설정합니다.",

    guideline_final_check_title: '가이드라인 최종 체크하기',
    guideline_final_check_description: '가이드라인에 이상이 없는지 마지막으로 확인해 주세요.',
    guideline_confirm_button: '확인',
    guideline_check_title: '가이드라인 확인',
    guideline_no_issue_confirmed: '이상 없음을 확인했습니다',
  },
  constants: {
    OPTION_TRANSLATION_MAP: {
      PHOTO_MODEL_FULL : '제품 착용샷 - 정면으로 서서 (머리, 발끝 잘리지 않게)',
      PHOTO_MODEL_HALF : '제품 착용샷 - 반신샷',
      PHOTO_MODEL_CLOSEUP : '제품 착용샷 - 제품 디테일 클로즈업',
      PHOTO_MODEL_WITHOUT_FACE : '제품 착용샷 - 얼굴 잘린 제품중심 샷',
      PHOTO_PRODUCT_FULL : '제품 단독샷 - 제품 전체샷',
      PHOTO_PRODUCT_CLOSEUP : '제품 단독샷 - 제품 디테일 클로즈업',
      REELS_BEAUTY_PRODUCT_SELFIE : '제품을 들고 찍은 셀피',
      REELS_BEAUTY_PRODUCT_TRY : '제품을 바르는 장면',
      REELS_BEAUTY_PRODUCT_FULL  : '제품 단독샷',
      REELS_PRODUCT : "제품 단독 컷",
      REELS_PRODUCT_PACKAGE : "패키지 단독 컷",
      REELS_PRODUCT_TEXTURE : "제형 표현 컷",
      REELS_PRODUCT_COLOR : "발색 표현 컷 (색조 제품인 경우 권장)",
      REELS_PRODUCT_TRY : "제품 사용 컷",
      REELS_PRODUCT_BEFORE_AFTER : "비포&애프터 컷",
      REELS_PRODUCT_SELFIE : "제품을 들고 찍은 셀피 컷",
      SUBTITLE_OPENING : "1초 후킹멘트",
      SUBTITLE_MIDDLE : "성능/효과/사용법",
      SUBTITLE_CLOSING : "행사 및 이벤트",
      CONTENT : "포스팅 글 내용 입력",
      VIDEO_DURATION : "영상 최소 길이",
      CO_AUTHOR : "공동 작업자 추가",
      PROHIBITIONS_MASK: "마스크 착용 금지",
      PROHIBITIONS_MIRROR_SELFIE: "거울 셀카 금지",
      PROHIBITIONS_OTHER_PEOPLE: "다른 사람과 함께 찍은 사진 금지",
      PROHIBITIONS_INDOORS: "실내 촬영 금지",
      PROHIBITIONS_PLACE_ROOFTOP: "옥상, 복도, 주차장, 집 촬영 금지",

      PROHIBITIONS_BEAUTY_GRWM_AND_OTHER_PRODUCTS: "겟레디윗미 금지, 증정 제품만 단독으로 소개",
      PROHIBITIONS_BEAUTY_MAKE_UP: "기초 제품인 경우, 반드시 생얼로 촬영",
      PROHIBITIONS_BEAUTY_TPO_MISMATCH: "제품 색상 및 분위기와 어울리는 의상 권장",
      PROHIBITIONS_BEAUTY_FINGERPRINTS: "제품이나 거울의 지문과 먼지는 반드시 닦고 촬영",
      PROHIBITIONS_BEAUTY_ENLARGE: "찍은 영상 확대 금지, 처음부터 클로즈업으로 촬영",
      PROHIBITIONS_BEAUTY_SLIDESHOW: "사진 짜깁기 방식의 편집 금지",
      PROHIBITIONS_BEAUTY_COMMERCIAL_CONTENTS: "저작권 이슈가 없는 폰트 및 음원만 사용",
      PROHIBITIONS_BEAUTY_HDR: "아이폰인 경우 반드시 HDR 설정을 끄고 촬영",
      PROHIBITIONS_BEAUTY_DEADZONE: "데드존에 자막, 로고 삽입 금지",

      REQUIREMENTS_IRONING: "제품 착용 전 다림질을 필수로 요청합니다.",
      REQUIREMENTS_VIDEO_CLEAN: "클린본 제출을 필수로 요청합니다.",

      HASH_TAG_LOCATION_POST: "포스팅 글 내에 포함",
      HASH_TAG_LOCATION_COMMENT: "포스팅 댓글에 포함",
      ALLOW_ADVERTISEMENT_TAG_ALLOW: "#광고 #협찬 태그 필수로 포함해주세요.",
      ALLOW_ADVERTISEMENT_TAG_DISALLOW: "#광고 #협찬 태그 미포함으로 권장하고 싶습니다.",
      ALLOW_OTHER_AT_TAG_ALLOW: "타 브랜드 태그를 함께 삽입해도 괜찮아요.",
      ALLOW_OTHER_AT_TAG_DISALLOW: "저희 브랜드 태그만 달아주세요.",
      VIDEO_DURATION_TWOWENTY: "20초 이상",
      VIDEO_DURATION_THIRTY: "30초 이상",

      PREFERRED_VIDEO_TYPE_EMOTIONAL: "감성형",
      PREFERRED_VIDEO_TYPE_INFOMATIVE: "정보전달형",
      PREFERRED_VIDEO_TYPE_VISITING: "방문형",
      PREFERRED_VIDEO_TYPE_OY_VISITING: "올영세일 방문형",
      PREFERRED_VIDEO_TYPE_OY_PRODUCT_ONLY: "올영세일 제품소개형",

      REQUIRE_PARTNERSHIP_CODE_REQUIRED: "필요합니다.",
      REQUIRE_PARTNERSHIP_CODE_NOT_REQUIRED: "필요 없습니다.",
    }
  },
  database: {
    posting_videos: {
      content_type_code_1: '클린본',
      content_type_code_2: '원본',
    },
    product: {
      status_fl_1: `제품정보 입력 완료`,
      status_fl_2: `제품 입고 및 검수 대기 중`,
      status_fl_3: `입고 중`,
      status_fl_4: `대여 진행 중`,
      status_fl_5: `반납요청 신청 완료`,
      status_fl_6: `반납요청 확인 완료`,
      status_fl_7: `반납 제품 발송 예정`,
      status_fl_8: `반납 완료`,
      status_fl_9: `계절 아웃`,
    },
    rental_posting_due: {
      reason_type_1: `배송지연`,
      reason_type_2: `가이드 위반 재촬영`,
      reason_type_3: `건강상의 문제`,
      reason_type_9: `기타`,
    },
    campaign_payments: {
      billing_type: {
        FREE: "현금",
        PAID: "카드",   
      },
    },
  },
  component: {
    ambassadorApplicantsToast: {
      _applicants: (n: number) => (
        <>
          {`엠버서더 모델 지원자가 `}
          <span className="text-[#000000] font-bold">{`${n}명 `}</span>
          {`있어요.`}
        </>
      ),
      button_select: "선정하러 가기"
    },
    buttonCleanVideoDownload: {
      pre_payment_modal_title: `클린본 다운로드 비용을 결제해 주세요.`,
      pre_payment_modal_description: [
        `완성된 릴스를 광고 소재로 활용하실 예정이라면`,
        `자막과 음악 없이 컷편집만 완료된`,
        `클린본 사용을 추천합니다.`,
        ``,
        `다운로드 받은 클린본은`,
        `기간 및 용도에 제한 없이 마음껏 활용 가능합니다.`
      ].join(`\n`),
    },
    campaignApplicantItem: {
      _modelSizeLine0: (age: number) => `${age}세`,
      _modelSizeLine1: (topSize: number, bottomSize: number) => ` / 상의 ${topSize}, 하의 ${bottomSize}`,
      _modelSizeLine2: (braSize: number, pantieSize: number) => ` / 브라 ${braSize}, 팬티 ${pantieSize}`,
      _modelSizeLine3: (shoesSize: number) => ` / 신발 ${shoesSize}`,
      modal_title_1: "출고완료",
      modal_title_2: "출고완료 해제",
      modal_text_1: "출고를 완료하셨습니까?",
      modal_text_2: "출고완료 상태를 해제 하시겠습니까?",
      prepared: "출고완료",
      prepared2: "출고완료됨"
    },
    campaignPaymentHistoryItem: {
      index_text_1: "현금결제",
      index_text_2: "카드결제",
      index_text_3: "세금계산서 발급 예정",
      index_text_4: "세금계산서 발급 불필요",
      index_text_5: "추가 선정",
      index_text_6: "세금계산서 발급 완료",
    },
    card: {
      modal_toggle_active_text: "해당 카드를 결제카드로 설정하시겠어요?",
      delete_card_text_1: "제품증정 자동결제 취소하기",
      delete_card_text_2: "제품대여 이용 중단하기",
      modal_alert_1_text: "이용 중인 서비스 이용중단부터 해주세요.",
      modal_delete_confirm: "해당 카드 정보를 삭제하시겠어요?",
      pay_card: "결제카드"
    },
    createEmergencyProductSub: {},
    createProductMasterModal: {
      category: '카테고리',
      parent_category: '상위 카테고리',
      child_category: '하위 카테고리',
      child_category_placeholder: '상위 카테고리를 먼저 선택해주세요.',
    },
    guideImage: {},
    guidelineCounter: {
      fashion_index_placeholder: `클로즈업 했으면 하는 특정 부위가 있으면 알려주세요. (예: 로고)`,
    },
    header: {},
    inputDate: {},
    modal: {},
    modalContactManager: {
      modal_contact_manager_index_1: "오미경 팀장",
      _modal_contact_manager_index_2: (name: string) => {
        if (name.length > 0)
          name = name + " ";
        return (
          <>
            {name}담당자님, 반갑습니다.
            <br />
            5분 이내로 전화드리겠습니다.
            <br />곧 만나요!
          </>
        )
      }
    },
    modelCard: {
      _modelsComment: (name: string) => `${name} 모델의 코멘트`,
      application_message_view: "지원 메시지 보기",
      _modelSize0: (age: number) => `${age}세`,
      _modelSize1: (height: number, topSize: number, bottomSize: number) => ` · ${height}cm · 상의 ${topSize} · 하의 ${bottomSize}`,
      _modelSize2: (shoesSize: number) => `신발 ${shoesSize}`,
      _modelSize3: (braSize: number, pantieSize: number) => `브라 ${braSize} · 팬티 ${pantieSize}`,
      _modelSelHistory: (name: string) => `${name} 모델의 최근 한 달 우리 브랜드 선정 이력`,
      _modelSelHistoryEntirePeriod: (name: string, number: number) => `${name}님은 지금까지 우리가 총 ${number}번 선정`,
      _modelProductsAppliedInBrand: (name: string, number: number) => `${name}님은 현재 우리 캠페인 총 ${number}개에 지원 중`,
      modal_reject_title_1: "모델 삭제하기 취소하기",
      modal_reject_title_2: "모델 삭제하기",
      modal_reject_text_1: "모델 삭제하기를 취소하시겠습니까?",
      modal_reject_text_2: `앞으로 우리 캠페인에서 제외하기${"\n"}**우리 브랜드 캠페인에 지원할 수 없도록 설정합니다.${"\n"}*모델은 제외 내용을 알 수 없습니다.`,
      non_bg_user: "배경사진을 등록하지 않은 사용자 입니다.",
      sel_history: "우리 브랜드가 선정 (최근 1달) : ",
      sel_history_entire_period: "우리가 선정한 적 있음 : ",
      products_applied_in_brand: "다른 캠페인에도 지원 중 : ",
      dibs_model_1: "찜했음",
      dibs_model_2: "인플루언서 찜하기",
      brand_like_influencer_1: "저장했음",    
      brand_like_influencer_2: "저장해두기", 
      product_like_influencer_1: "찜했음",                   
      product_like_influencer_2: "이 캠페인에서만 찜하기", 
      brand_like_modal_menu_info_1: "'인플루언서' 메뉴에서 확인 가능",
      brand_like_modal_menu_info_2: "저장해둔 인플루언서는 홈페이지 상단의\n'인플루언서' 메뉴에서 확인 가능합니다.",
      extended_posting_deadline: "포스팅 기한을 연장하였습니다.",
      exceeded_posting_deadline: "포스팅 기한이 초과되었습니다.",
      exceeded_inspection_deadline: "사전 검수 파일 제출 기한이 초과되었습니다.",
      select_model_1 : "모델 선택됨",
      select_model_2 : "모델 선택하기",
      suggested_by_admin : `${getServiceName()} 추천`,
      new_influencer_within_30_days: '신입',
      ambassador_approved: `앰베서더 선정`,
      brand_reselected: `브랜드의 재선택`,
      should_check_reels_modal_title: `릴스 작업물을 반드시 확인해 주세요.`,
      should_check_reels_modal_text: `화장품을 들고 사진을 잘 찍는 것은 매우 쉽습니다. 반드시 릴스 제작 경험 및 역량이 있는 지를 확인해 주세요.`,
      not_visible_today: `오늘 하루 안보기`,
      commission_amount_applied : (price, unit) => `${price}만${unit}으로 지원`,
      increased_commission_amount_applied: (price, unit) => `${price}만${unit}으로 상향 지원`,
      original_commission_amount_applied: (price, unit) => `${price}만${unit} 그대로 지원`, 
      influencer_message_button_text: '선정 시 보낼 메세지 입력해두기',
      influencer_message_button_text_completed: '입력 완료',
      influencer_message_button_text_cannot_modify_message : '선정 시 보낸 메세지 보기',
      influencer_message_button_text_cannot_modify_empty_message : '선정 시 보낸 메세지 없음',
      message_modal_title: '선정 시 보낼 메시지 미리 입력해두기',
      message_modal_seelct_title: '선정된 인플루언서에게 보낼 메시지 입력하기',
      message_modal_model_type_suggested: '추천 모델',
      message_modal_model_type_normal: '일반 모델',
      message_modal_representative_reels_view: '대표 릴스 보기',
      message_modal_placeholder: '(예) 이번에 잘 만들어주시면, 매달 의뢰할 생각이 있습니다.',
      message_modal_comfirm : '완료',
      message_modal_desc:'입력하신 내용은 인플루언서가 필수적으로 지켜야 할 의무가 없습니다.',
      message_model_not_input : '보냈던 메시지가 없습니다.',
      message_modal_title_not_modify:'선정 시 보낸 메시지 보기'
    },
    notification: {},
    matchRatingsEditor: {
      index_text_1: `우리 브랜드의 스타일을 \n중요도 순으로 모두 선택해주세요.`,
      index_text_2: `우리 브랜드에 \n해당되는 카테고리가 있으면 선택해 주세요.`,
      index_text_3: `아예 보지 않았으면 하는 \n카테고리의 모델이 있으면 선택해 주세요.`,
      index_text_4: `수정되었습니다.`,
      index_text_5: `스타일`,
      index_text_6: `우리 브랜드에 해당되는 카테고리 (선택)`,
      index_text_7: `해당되는 카테고리가 있는 경우에만 선택해 주세요.`,
      index_text_8: `아예 보지 않았으면 하는 카테고리의 모델 (선택)`,
    },
    overlayBrandTaxInvoiceInfoForm: {
      index_text_title: '이 캠페인의 세금계산서 발급 정보',
      index_text_tax_invoice_date_title: '세금계산서 발급 날짜',
      index_text_deposit_date_title: '입금 예정일',
      _index_text_download_business_registration_certificate: (serviceName: string) => `${serviceName} 사업자등록증\n다운로드`,
      _index_text_download_copy_of_bankbook : (serviceName: string) => `${serviceName} 통장사본\n다운로드`,
      index_text_business_name: '사업자등록증의 회사명',
      index_text_business_ceo_name: '대표자명',
      index_text_business_number: '사업자등록번호',
      index_text_business_email: '세금계산서용 이메일',
      index_text_error_business_number: '사업자등록번호는 10자리 숫자만 입력 가능합니다.',
      index_text_error_emails_count: '이메일은 최대 2개만 입력 가능합니다.',
      index_text_warning_1_title: `이메일 변경 시 주의사항`,
      index_text_warning_1_description: `여기서 이메일을 변경하면,\n브랜드 정보 및 모든 캠페인의 세금계산서용 이메일 정보에 반영됩니다.`,
    },
    overlayMatchRatingSetting: {
      index_text_1: `우리 브랜드의 스타일을 \n중요도 순으로 모두 선택해주세요.`,
      index_text_2: `우리 브랜드에 \n해당되는 카테고리가 있으면 선택해 주세요.`,
      index_text_3: `아예 보지 않았으면 하는 \n카테고리의 모델이 있으면 선택해 주세요.`,
      index_text_4: `수정되었습니다.`,
      index_text_5: `브랜드 정보에도 적용됩니다.`,
      index_text_6: `여기서 바꾸신 내용은\n브랜드 정보에도 적용됩니다.`,
      index_text_7: `다시 보지 않기`,
    },
    photoGuidelines: {
      _modal_text: (limit: any) => `사진은 ${limit}장을 넘을 수 없습니다.`,
      modal_title: "사진 최대 수량 제한",
      index_text_1: "기타 필수 전달사항 입력 (선택)",
      index_text_2: "내용",
      index_text_3: `필수 사진의 총 합은 4개가 적당합니다.\n사진 수가 늘어나면 인플루언서 참여율이 낮아집니다.`,
    
      _index_text_4: (current:number, maximum:number)=>(
        `(${current}/${maximum} ${maximum}자 이내)`
      ),
    },
    reelsGuidelines: {
      _modal_text: (limit: any) => `사진은 ${limit}장을 넘을 수 없습니다.`,
      modal_title: "사진 최대 수량 제한",
      index_text_before_after_warning_ja: "*해당 컷이 필요한 경우, 일본 약사법 기준을 준수하여 작성해 주시기 바랍니다. 과도한 표현이나 문구, 변화 강조 등은 피해 주시기 바랍니다.",
      index_text_3: `필수 사진의 총 합은 4개가 적당합니다.\n사진 수가 늘어나면 인플루언서 참여율이 낮아집니다.`,
      index_text_5: `필수 장면을 5개 선택하셨습니다.`,
      index_text_6: `6개부터는 지원율이 감소할 수 있으니\n꼭 필요한 장면인지 고민 후 선택해 주세요.`,
    },
    popup: {},
    posting: {
      model_supporting: "밀어주기 중",
      model_rejecting: "제외하기 중",
      model_support: "밀어주기",
      mode_reject: "제외하기"
    },
    postingCard: {
      brandRequestCreateButton: {
        index_1: "원본 및 클린본 파일이 당장 필요하신가요?",
        modal_request_step_1_title: "원본, 클린본 파일이\n당장 필요하신가요?",
        modal_request_step_1_content: "글로브 검수팀에게\n‘지금 즉시 검수완료 처리’를 요청해 주시면,\n\n" + 
          "확인 후 원본, 클린본 파일을 받으실 수 있게\n바로 상태를 변경해 드립니다.\n\n" +
          "다만 이렇게 상태를 변경하는 경우,\n\n" + 
          "인플루언서에게 추가적인 수정 요청은 불가능해지니\n주의해 주시기 바랍니다.\n\n" + 
          "지금 즉시 검수완료 처리를 요청하시겠습니까?",
        modal_request_step_1_confirm: "검수완료 처리 요청하기",
        modal_request_step_2_title: "검수완료 처리 요청 전달 완료",
        modal_request_step_2_content: "글로브 검수팀에게\n검수완료 처리 요청이 전달되었습니다.\n\n" +
          "원본, 클린본 파일을 받으실 수 있도록\n확인 후 바로 상태를 변경해 드리겠습니다.",
      },
      validationStatusIndicator: {
        posting_status_validating: "deprecated_포스팅 검수 중",
        posting_status_validated: "deprecated_포스팅 검수 완료",
        posting_status_modifying: "deprecated_포스팅 수정 대기 중",
        _posting_status_modifying: () => (
          <>
            포스팅이 가이드라인을 위반했기 때문에<br />
            수정 요청을 해둔 상태입니다.
          </>
        ),
        posting_status_revalidating: "deprecated_수정된 포스팅 검수 중",
        _posting_status_revalidating: () => (
          <>
            수정해서 다시 올라온 버전을<br />
            다시 검수 중입니다.
          </>
        ),
        btn_open_feedbacks_modal: "위반내용 보기",
      },
      _createdAtDate: (date: string) => `${date}에 등록했습니다.`,
      _modelWear1: (colorName: string, shoesSize: number) => `${colorName} / ${shoesSize} 착용`,
      _modelWear2: (colorName: string, braSize: number, pantieSize: number) => `${colorName} / ${braSize} / ${pantieSize} 착용`,
      _modelWear3: (colorName: string, sizeName: number) => `${colorName} / ${sizeName} 착용`,
      _modelSize1: (age: number, height: number, topSize: number, bottomSize: number) => `${age}세 / ${height}cm / 상의 ${topSize}, 하의 ${bottomSize} `,
      _modelSize2: (braSize: number, pantieSize: number) => `/ 브라 ${braSize} / 팬티 ${pantieSize} `,
      _modelSize3: (shoesSize: number) => `/ 신발 ${shoesSize} / `,
      _modelWarningReason: (reason: string) => `사유 : ${reason}`,
      _modelReshootingDate: (date: string) => `재촬영 예정일 : ${date}`,
      _dayPassed: (diff: number) => `${diff}일 초과`,
      _dayRemaining: (diff: number) => `${diff}일 남음`,
      dayToday: `오늘까지`,
      model_suggested: "추천모델",
      model_not_suggested: "일반모델",
      rating_tooltip: "별점 평가는 모델에게 공유되지 않습니다. 솔직한 평가 부탁드립니다",
      model_reject_1: "캠페인 지원 금지 해제하기",
      model_reject_2: "캠페인 지원 금지 요청하기", 
      model_reject_3: "제품 착용 금지 해제하기",
      model_reject_4: "제품 착용 금지 요청하기",
      modal_alert_download: "타 브랜드의 원본 사진은 다운로드할 수 없습니다.",
      downloaad_all_images: "사진 전체 다운로드",
      not_include_persons_tag: "인물태그 미포함",
      model_guideline_warning: "모델에게 가이드라인 위반으로 주의를 주었습니다.",
      model_likes_1: "찜했음",
      model_likes_2: "인플루언서 찜하기",
      brand_like_influencer_1: "저장했음",    
      brand_like_influencer_2: "저장해두기", 
      brand_feedback_btn_text: "이 릴스 또는 인플루언서에 불만족하셨나요?",
      brand_feedback_modal_1_title: `릴스 또는 인플루언서에 대한 피드백 남기기`,
      brand_feedback_modal_1_text: `릴스 제작과 관련하여 불만족스러운 부분이 있으셨나요?\n\n피드백을 남겨주시면 글로브 팀이 즉시 확인 후,\n인플루언서 평가 시 가장 중요한 기준으로 사용하게 됩니다.\n\n최대한 솔직한 의견 부탁드립니다.`,
      brand_feedback_modal_2_title: `피드백 제출 완료`,
      brand_feedback_modal_2_text: `솔직한 의견 감사드립니다.`,
      index_text_1: "위반내용",
      index_text_2: "포스팅에 들어가야할 필수 문구를 입력하지 않았어요.",
      _index_text_3: () => <>미리 준비하는 겨울 가방 추천! 탈부착이 가능한 스트랩 2종으로 날마다 다른 스타일로 변신 가능!</>,
      index_text_4: "인물 태그를 포스팅 첫번째 장에 삽입하지 않았어요.",
      _index_text_5: () => <>인물 태그로 다른 브랜드 태그 또는 본인 계정 태그를 함께 삽입했어요.</>,
      index_text_6: "해시 태그를 포스팅 글 내에 기입하지 않았어요.",
      _index_text_7: () => <>@hoze #HOZE #MYHOZE #겨울스타일링 #겨울가방추천 #데일리백 #여자가방 #크리스마스선물</>,
      index_text_8: "해시 태그를 댓글에 기입하지 않았어요.",
      _index_text_9: () => <>@hoze #HOZE #MYHOZE #겨울스타일링 #겨울가방추천 #데일리백 #여자가방 #크리스마스선물</>,
      index_text_10: "해시 태그를 댓글이 아닌 포스팅 글에 기입했어요.",
      _index_text_11: () => <>@hoze #HOZE #MYHOZE #겨울스타일링 #겨울가방추천 #데일리백 #여자가방 #크리스마스선물</>,
      index_text_12: "해시 태그를 포스팅 글이 아닌 댓글에 기입했어요.",
      _index_text_13: () => <>@hoze #HOZE #MYHOZE #겨울스타일링 #겨울가방추천 #데일리백 #여자가방 #크리스마스선물</>,
      index_text_14: "릴스가 가이드라인을 위반했습니다.",
      _index_text_15: () => <>밝게 웃어주세요! 밝게 웃어주세요! 밝게 웃어주세요! 밝게 웃어주세요! 밝게 웃어주세요! 밝게 웃어주세요! 밝게 웃어주세요!</>,
      _index_text_16: () => <>위반 내용: 머리, 발끝이 잘렸고, 배경이 편의점이고, 거울셀카를 찍었어요.</>,
      index_text_17: "가이드라인 위반한 릴스:",
      index_text_18: "다시 올린 릴스:",
      index_text_19: "사진이 가이드라인을 위반했습니다.",
      _index_text_20: () => <>위반 내용: 머리, 발끝이 잘렸고, 배경이 편의점이고, 거울셀카를 찍었어요.</>,
      _index_text_21: () => (
        <>
          모델이 올린 <br /> 가이드라인 위반 사진
        </>
      ),
      _index_text_22: () => (
        <>
          모델이 <br /> 다시 올린 사진
        </>
      ),
      index_text_30: "부위",
      index_text_31: "착용샷 - 전신",
      index_text_32: "착용샷 - 반신",
      index_text_33: "착용샷 - 클로즈업",
      index_text_34: "제품샷 - 전체",
      index_text_35: "제품샷 - 클로즈업",
      index_text_36: "위반사항 요청 중 에러가 발생했습니다.\n새로고침 후 다시 시도해주세요.",
      index_text_37: "검수 완료",
      index_text_38: "검수 중",
      index_text_39: "수정 대기 중",
      index_text_40: "수정본 검수 중",
      index_text_41: "착용샷 - 얼굴 잘린 제품 중심샷",
      reels_creation_deadline: "릴스 제작 기한",
      validation_status_inspection_initial: "사전 검수 기간",
      validation_status_inspection_fixed: "수정 및 업로드 준비 중",
      validation_status_inspection_validating: "최종 검수 중",
      clean_video_container_title: `클린본 파일`,
      clean_video_container_description_1: `검수가 완료되면 다운로드가 가능합니다.`,
      clean_video_container_description_2: `기간 및 용도 제한 없이 마음껏 활용 가능합니다.`,
      inspection_initial_video_container_title: `사전검수 파일`,
      inspection_initial_video_container_description_1: `검수가 완료되면 다운로드가 가능합니다.`,
      inspection_initial_video_container_description_2: `기간 및 용도 제한 없이 마음껏 활용 가능합니다.`,
      inspection_fixed_video_container_title: `수정본 파일`,
      inspection_fixed_video_container_description_1: `검수가 완료되면 다운로드가 가능합니다.`,
      inspection_fixed_video_container_description_2: `기간 및 용도 제한 없이 마음껏 활용 가능합니다.`,
      published_video_container_title: `원본 파일`,
      published_video_container_description_1: `검수가 완료되면 다운로드가 가능합니다.`,
      published_video_container_description_2: `기간 및 용도 제한 없이 마음껏 활용 가능합니다.`,
      video_description : <>아래 이메일로<br/>파일을 보내드립니다.</>,
      partnership_code_title: `파트너십 광고 코드`,
      partnership_code_description_not_validated: `검수가 완료되면 확인이 가능합니다.`,
      partnership_code_description_empty: `입력된 코드가 없습니다`,
      inspection_created_date: (date) => `${date} 제출`,
      inspection_campaign_title : `사전 검수 캠페인`,
      inspection_status_completed : `검수 종료`,
      inspection_remain_time : (remainTimeStr) => `${remainTimeStr} 안에 검수하기`,
      feedback_reason_title_1: `필수 장면이 영상에 포함되지 않았어요.`,
      feedback_reason_title_2: `필수 장면 관련 세부 전달사항을 지키지 않았어요.`,
      feedback_reason_title_3: `필수 장면 관련 기타 전달사항을 지키지 않았어요.`,
      feedback_reason_title_4: `증정 제품 외 다른 제품까지 영상에서 함께 소개했어요.`,
      feedback_reason_title_5: `기초 제품임에도 불구하고 생얼로 촬영하지 않았어요.`,
      feedback_reason_title_6: `제품 색상 및 분위기와 어울리지 않는 의상이에요`,
      feedback_reason_title_7: `제품이나 거울의 지문과 먼지를 닦지 않고 촬영했어요.`,
      feedback_reason_title_8: `찍은 영상을 확대해서 사용하는 바람에 화질이 많이 낮은 영상이 제작됐어요.`,
      feedback_reason_title_9: `사진 짜깁기 방식의 편집을 진행했어요.`,
      feedback_reason_title_10: `저작권 문제가 있는 폰트 및 음원을 사용했어요.`,
      feedback_reason_title_11: `영상 최소 길이를 지키지 않았어요.`,
      feedback_reason_title_12: `자막으로 들어가지 않은 내용이 있어요.`,
      feedback_reason_title_13: `포스팅 글에 들어가지 않은 내용이 있어요.`,
      feedback_reason_title_14: `사람 태그를 삽입하지 않았어요.`,
      feedback_reason_title_15: `포스팅 글 또는 댓글에 삽입해야 하는 태그를 삽입하지 않았어요.`,
      feedback_reason_title_16: `공동 작업자 추가를 하지 않았어요.`,
      feedback_reason_title_17: `선호하는 영상 타입을 지키지 않았어요.`,
      feedback_reason_title_18: `브랜드가 전달한 필수 가이드라인을 지키지 않았어요.`,
      feedback_reason_title_19: `브랜드 로고 파일이 사용되지 않았어요.`,
      feedback_reason_title_20: `HDR 설정을 켜고 촬영했어요.`,
      feedback_reason_title_21: `잘못된 클린본 영상을 올렸어요.`,
      feedback_reason_title_22: `데드존에 자막, 로고를 삽입했어요.`,
      feedback_reason_title_23: `브랜드가 특정 장면에 남긴 피드백을 지키지 않았어요.`,
      feedback_reason_title_24: `자막 폰트 변경(영상 전체에 적용)을 하지 않았어요.`,
      feedback_reason_title_25: `자막 크기 변경(영상 전체에 적용)을 하지 않았어요.`,
      feedback_reason_title_26: `배경음악을 교체를 하지 않았어요.`,
      feedback_reason_title_27: `나레이션 추가를 하지 않았어요.`,
      feedback_reason_title_28: `나레이션 수정을 하지 않았어요.`,
    },
    product: {
      load_error_1: "제품 정보를 불러올 수 없습니다."
    },
    sheet: {},
    sidebar: {
      _alertUsePc1: () => (
        <>
          PC의 제품정보 입력 탭을 <br /> 통해 개설해주시길 바랍니다.
        </>
      ),
      _alertUsePc2: () => (
        <>
          PC의 제품증정 탭을 통해 <br /> 개설해주시길 바랍니다.
        </>
      )
    },
    snsPaymentHistoryItem: {},
    seedingWithCommissionsAlert : {
      products_count_options: [
        { name: "1", value: 1 },
        { name: "2", value: 2 },
        { name: "3", value: 3 },
        { name: "5", value: 5 },
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 },
        { name: "50", value: 50 },
        { name: "100", value: 100 },
      ],
      amount_options: [
        { name: "3", value: 30000 },
        { name: "5", value: 50000 },
        { name: "10", value: 100000 },
        { name: "20", value: 200000 },
        { name: "30", value: 300000 },
        { name: "50", value: 500000 },
      ],
      _title : ()=> (
        <>원고료 지급하고,
        <br /> 더 좋은 인플루언서 이용해 보세요!
        </>),
      _title_for_shirts : ()=> (
      <>티셔츠는 카테고리 특성 상<br/>
        지원률이 저조할 수 있습니다.<br/>
        <br/>
        원고료 추가로 지급하고,<br/>
        지원률을 높여보세요!
        </>),
      _title_for_underwear : ()=> (
      <>언더웨어는 카테고리 특성 상<br/>
        지원률이 저조할 수 있습니다.<br/>
        <br/>
        원고료 추가로 지급하고,<br/>
        지원률을 높여보세요!
        </>),
      _title_for_reels : ()=> (
      <>
      제작 난이도가 높은 릴스의 특성 상<br/>
        지원률이 저조할 수 있습니다.<br/>
        <br/>
        원고료 추가로 지급하고,<br/>
        지원률을 높여보세요!
        </>),
      _body : (unit: string) => (
      <>
        <p>원고료를 지급하면, <span className="#FF0099 font-bold">평균 3배 이상</span> 지원률이 올라갑니다.</p>
        <p>평소에 볼 수 없었던 <span className="#FF0099 font-bold">좋은 인플루언서가 참여</span>합니다.</p>
        <br/>
        <br/>
        <br/>
        <p className="font-bold">1. 캠페인 생성 후 ‘원고료 지급 적용하기’ 버튼 클릭</p>
        <img className="w-full mt-[20px]" src="/assets/images/commissions/commissions-image-01.png" />
        <br/>
        <br/>
        <p className="font-bold">2. 원고료 금액 설정하기</p>
        <p>릴스, 티셔츠, 속옷의 경우 최소 5만{unit}을 권장합니다.</p>
        <img className="w-full mt-[20px]" src="/assets/images/commissions/commissions-image-02.png" />
        <br/>
        <br/>
        <p className="font-bold">3. 결제 후 원하는 인플루언서가 없거나 너무 많은 경우</p>
        <p>수량 변경을 원하시면 환불 또는 추가 결제를 도와드립니다.</p>
      </>
      ),
      try_calculate : '예상 비용 계산해보기',
      calculate_amount : '예상 비용 계산해보기',
      calculate_result: '총 예산: ',
      _calculate_unit : (unit: string) => unit,
      products_count_unit : '개',
      _amount_currency_unit : (unit: string) => `만${unit}`,
      submit_inquiery : '원고료 지급 기능 문의하기',
      block_until_next_week : '일주일 동안 보지않기',
      store_contact_msg : '증정 + 수수료 이용 문의',
      store_contact_reels_request_msg : 'DEPRECATED_해당 제품의 산출물 유형 변경을 요청하시겠습니까?',
      store_contact_reels_msg : 'DEPRECATED_대여 제품 릴스 문의',
      seeding_with_commisions_heading : '원고료 지급하고, 더 좋은 인플루언서를 이용해 보세요!',
      seeding_with_commisions_description : '인플루언서에게 제품증정과 더불어 추가 금액을 지불하는 기능입니다.',
      show_detail : '자세히 보기',
    },
    checkbox : {
      recommend : '권장'
    }
  },
  helper: {
    reactHookForm: {
      error_undefined: '입력값을 확인해주세요.',
      _error_required: (fieldName:string) => `${fieldName}을(를) 입력해주세요.`,
      _error_pattern: (fieldName:string) => `${fieldName} 형식이 올바르지 않습니다.`,
      _error_validate: (fieldName:string) => `${fieldName}이(가) 유효하지 않습니다.`,
    },
    ui: {
      single_day_posting_product_tag: (postingDateText:string) => `[${postingDateText} 업로드 필수]`,
    },
    versionChecker: {
      important_update_detected_force: '중요 업데이트가 감지되어 새로고침을 실행합니다.',
      important_update_detected_confirm: '중요 업데이트가 감지되었습니다. 새로고침을 실행하시겠습니까?',
      important_update_detected_delayed: '업데이트를 지연했습니다.\n현재 작업 완료 후, 최신 버전을 사용하기 위해 새로고침을 실행해주세요.',
    },
  },
  pages: {
    auth: {
      title: `${getServiceName()} 관리자 페이지`,
      login_first: "먼저, 로그인을 해주세요.",
      desc_1: "아이디, 비밀번호가 기억나지 않으시면",
      desc_2: "아래 번호로 연락주세요.",
      manager: "운영 매니저",
      manager_tel: "010-9635-9152",
      _contact_text: (url: string) => (
        <p>
          제휴문의는 &nbsp;
          <a href={url} className="underline" target="_blank">
            여기
          </a>
          를 눌러주세요.
        </p>
      )
    },
    influencers: {
      previously_selected_influencer_title: "선정한 적 있는 인플루언서",
      previously_selected_influencer_desc: `만족스러웠던 인플루언서에게 먼저 제안을 할 수 있는 기능을 준비 중입니다.\n가이드라인 및 기한 미준수, 낮은 퀄리티 등의 이유로 글로브 활동 권한이 박탈당한 인플루언서는 보이지 않을 수 있습니다.`,
      brand_liked_influencer_title: "저장해둔 인플루언서",
      brand_liked_influencer_desc: `저장해둔 인플루언서에게 우리 캠페인에 지원해 달라고 부탁해 보세요.\n가이드라인 및 기한 미준수, 낮은 퀄리티 등의 이유로 글로브 활동 권한이 박탈당한 인플루언서는 보이지 않을 수 있습니다.`,
      no_influencers_found: "해당하는 인플루언서가 없습니다.",
      show_text_sort_by_brand_liked_influencers_date: "저장순",
      show_text_sort_by_brand_liked_influencers_followers: "팔로워순",
      show_text_sort_by_brand_liked_influencers_previously_selected: "선정한 적 많은 순",
      show_text_new_influencers: "신입 인플루언서",
      show_text_recommended_influencers: "추천 인플루언서"
    },
    campaigns: {
      create: {
        components: {
          preferredVideoTypeSelector: {
            btn_no_preferred_video_type: "DEPRECATED_특별히 없음",
            btn_show_example: "예시 보기",
            btn_oy_visiting: "12월 올영세일 매장 방문형",
            btn_oy_product_only: "12월 올영세일 제품만 소개형",
          },
        },
      },
      payments: {
        groupedByCampaign: {
          index_text_1: "결제내역",
          index_text_2: "개설",
          index_text_3: "미래 날짜를 선택하시면 세금계산서 발급 예정인 건을 확인하실 수 있습니다.",
          index_text_4: (qty:number) => ` 외 ${qty}개`,
          index_duration_type_option_1: "캠페인 개설",
          index_duration_type_option_2: "세금계산서 발급",
          index_duration_type_option_3: "카드 결제일",
          index_duration_preset_1: "deprecated_전체기간",
          index_duration_preset_2: "deprecated_지난 달",
          index_duration_preset_3: "deprecated_이번 달",
          index_duration_preset_4: "deprecated_다음 달",
          index_duration_preset_5: "deprecated_다다음 달",
        },
      },
      stepOne: {
        modalInspectionAgreements : {
          title: `사전 검수 필수 동의사항`,
          _agreement_1: (priceText: string) => `·  ${priceText} 비용 부과`,
          agreement_2: `·  검수 및 수정 요청은 1회만 가능`,
          agreement_3: `·  재촬영을 제외한 자막, 폰트 등의 수정 요청 가능`,
          agreement_4: `·  배경음악이 삽입되지 않은 버전을 받아볼 가능성 존재`,
          agreement_5: `·  검수 기한이 지나면 피드백 입력 화면이 자동으로 종료되며, 인플루언서가 그 즉시 인스타그램 업로드를 시작하므로`,
          agreement_6: `·  검수 기한을 놓치지 않도록 주의해 주시기 바랍니다.`,
          check_is_agreed: `동의합니다.`,
        }
      },
      _createPaymentText1: (date: string) => (
        <>
          {date}까지 이용이 가능하시지만, <br />
          이번에 생성하는 캠페인이 이 날짜를 초과하므로 추가 결제가 필요합니다.
        </>
      ),
      _createPaymentText2: (days: number, price: number, unit:string) => (
        <>
          지금 무제한 이용으로 결제하시면,
          <br /> {days}일에 {price / 10000}만 {unit}으로 제품 증정 캠페인을 무한으로
          <br /> 이용할 수 있습니다.
        </>
      ),
      _createPaymentUnlimitedPrice: (days: number, price: number, unit: string) => `무제한 : ${days}일에 ${price / 10000}만 ${unit}`,
      _createPaymentText23: (days) => (
        <>
          {days}일 뒤에 자동결제 되고, 원하는 때 자동결제 취소 가능합니다.
          <br />
          자동결제 후 환불이 불가합니다.
        </>
      ),
      _excelError1: (lines: Array<string>) => `혹시 다운받으신 엑셀의 내용을 변경하셨나요? 변경하면 안됩니다. ‘운송장번호' 열에 운송장번호만 추가해서 업로드를 해주세요.

            문제가 있는 행
            ${lines.join()}`,
      _filterExcelTooltip: () => <>배송정보 엑셀을 먼저 다운받으신 후 ‘운송장 번호' 열에 운송장 번호를 입력 후 그 파일을 업로드 하시면 됩니다.</>,
      _excelButton1: (n: number) => `${n}개 제품 모델 정보 엑셀 출력하기`,
      option_1: "진행중",
      option_2: "완료",
      product_prepared: "출고완료",
      header_title: "제품 증정 캠페인",
      header_button_1: "캠페인 소개 보기",
      header_button_2_1: "제품 증정&nbsp;",
      header_button_2_2: "캠페인 개설하기",
      filter_check_1: "모델 선정해야하는 캠페인",
      filter_check_2: "제품 발송해야하는 캠페인",
      filter_check_3: "운송장 번호 입력 안한 캠페인 모아보기",
      tracking_number_required_title: '운송장 번호를 반드시 입력해 주세요.',
      tracking_number_required_description: '해외 배송이기 때문에 운송장번호 미입력 시, 분실에 대한 확인이 불가합니다.',
      tracking_number_bulk_input_guide: '운송장 번호 한번에 입력하는 방법 보기',
      _tracking_number_guide_title: () => (
        <>
          엑셀로 운송장 번호<br />
          한번에 입력하는 방법
        </>
      ),
      tracking_number_guide_01: '1. 엑셀 파일 다운로드',
      tracking_number_guide_02: '목록에서 체크박스를 누른 뒤 엑셀 파일을 다운로드합니다.',
      tracking_number_guide_03: '2. 엑셀 파일에 운송장 번호 입력',
      tracking_number_guide_04: `엑셀 파일에 ‘운송장 번호'를 모두 입력 후 저장합니다.`,
      tracking_number_guide_05: `3. ‘엑셀로 운송장 번호 한번에 업로드하기' 버튼으로 업로드하기`,
      tracking_number_guide_06: `위 버튼을 눌러 방금 저장한 엑셀 파일을 업로드합니다.`,
      filter_excel_title: "엑셀로 운송장 번호 한번에 업로드하기",
      filter_excel_tooltip: "배송정보 엑셀을 먼저 다운받으신 후 ‘운송장 번호' 열에 운송장\n번호를 입력 후 그 파일을 업로드 하시면 됩니다.",
      seeding_with_commission_title: "원고료 지급하고, 더 좋은 인플루언서 이용하기",
      seeding_with_commission_tooltip: () => (
        <>
          인플루언서에게 제품증정과 더불어 추가금액을
          <br />
          지불하는 기능입니다.
          <br />
          해당 기능은 {getServiceName()} 팀원이 밀착하여 대응합니다.
          <br />
          버튼을 누르면 5분 내에 전화드리겠습니다.
        </>
      ),
      order_check_1: "지원자  많은 순",
      order_check_2: "캠페인 생성 순",
      fetch_text1: "아직 포스팅이 완료된 제품 증정 캠페인이 없습니다.",
      fetch_text2: "조회된 캠페인이 없습니다.",
      product_selected: "모델 선정 완료",
      product_selection_started_title: "모델 선정 기간입니다.",
      product_selection_started_button_1: "모델 선정하기",
      product_posting_started_title: "포스팅 제작 및 업로드 기간",
      product_seeding_pass_1: "시딩 패스를 이용해서 생성된 캠페인 입니다.",
      campaign_with_commissions: "원고료 지급 캠페인",
      product_apply_commissions: "원고료 지급 적용하기",
      product_apply_commissions_applied: "원고료 지급 적용됨",
      product_apply_commissions_already_applied: "원고료 지급이 이미 적용된 제품 입니다.",
      _product_apply_commissions_minimum_amount: (amount: number, currencyText: string) => `원고료 지급 기능은 최소 ${amount}${currencyText}부터 이용 가능합니다.`,
      campaign_form_header_title_1: ({ updateCampaignId }:
        Pick<CampaignFormContextProps, 'updateCampaignId'>) =>
          updateCampaignId ? '캠페인 정보 수정' : '캠페인 정보 등록',
      campaign_form_header_title_2: ({ updateCampaignId, categoryId }:
        Pick<CampaignFormContextProps, 'updateCampaignId'>
        & Pick<BrandDto, 'categoryId'>
      ) => {
        switch (categoryId) {
          case CATEGORY_ID.BEAUTY:
            return updateCampaignId ? '영상 및 포스팅 가이드라인 수정' : '영상 및 포스팅 가이드라인 설정'
          default:
            return updateCampaignId ? '포스팅 가이드라인 수정' : '포스팅 가이드라인 설정'
        }
      },
      campaign_form_header_title_3: ({ updateCampaignId }:
        Pick<CampaignFormContextProps, 'updateCampaignId'>) => 
          updateCampaignId ? '담당자 정보 수정' : '담당자 정보 입력',
      campaign_form_header_desc_1: ({ categoryId }:
        Pick<BrandDto, 'categoryId'>) => {
        switch (categoryId) {
          case CATEGORY_ID.BEAUTY:
            return <>캠페인에 참여하는 인플루언서에게 전달되는 내용이며,<br/>높은 퀄리티의 릴스 제작을 위해 정확한 정보를 입력해 주세요.</>;
            default:
            return <>캠페인에 참여하는 인플루언서에게 전달되는 내용이며,<br/>높은 퀄리티의 포스팅을 위해 정확한 정보를 입력해 주세요.</>;
        }
      },
      campaign_form_header_desc_2:({ categoryId }:
        Pick<BrandDto, 'categoryId'>) => {
          switch (categoryId) {
            case CATEGORY_ID.BEAUTY:
              return <>캠페인 및 릴스 제작 상황을 공유받을<br/>담당자 정보를 입력해 주세요.</>;
            default:
              return <>잘못된 제품 배송으로 모델이 반품을 요청하는 경우 받으실 주소를 입력해 주세요.</>;
          }
      },
      campaign_form_past_campaigns_modal_button: '과거 캠페인 정보 불러오기',
      campaign_form_past_campaigns_modal_search_placeholder: '제품명 검색',
      campaign_form_past_campaigns_modal_campaigns_empty:'생성된 내역이 없습니다.',
      campaign_form_past_campaigns_modal_campaign_created_at: (date: string) => `캠페인 (${date} 생성)`,
      campaign_form_brand_description_field_label: '브랜드 한 문장 소개',
      campaign_form_brand_description_field_placeholder: (maxLength: number) => `입력 (${maxLength}자 이내)`,
      campaign_form_products_field_label: '제품정보',
      campaign_form_products_field_desc: (isCategoryFashion: BrandDto['isCategoryFashion']) => isCategoryFashion ? <>셋업으로 증정하시는 경우는 한 번에 업로드 해주세요.<br />상세이미지를 많이 업로드 할수록 모델의 선택률이 높아집니다.</> : null,
      campaign_form_products_field_add_btn: '제품정보 추가하기',
      campaign_form_products_field_input_btn: '제품정보 입력하기',
      campaign_form_commission_field_label: '원고료 설정',
      campaign_form_commission_field_sub_label: '제품 당 원고료',
      campaign_form_commission_field_reference_text_1: '레퍼런스 모음',
      campaign_form_commission_field_reference_text_2: '에 있는 릴스의 평균 원고료는 30~40만원 선입니다.',
      campaign_form_commission_field_amount: '제품 수량',
      campaign_form_commission_field_amount_units: '개',
      campaign_form_commission_field_total: '총 원고료',
      campaign_form_commission_field_description: '결제는 캠페인 생성 마지막 단계에서 진행합니다.',
      campaign_form_commission_field_increase_max_step_label: '조금 더 실력있는 인플루언서의 지원도 함께 받아보기',
      campaign_form_commission_field_increase_max_step_sub_label: (moneyText: string) => `${moneyText}보다 높은 캠페인에만 참여하는 소수의 글로브 추천 인플루언서들이\n이번 캠페인에 원고료를 높여 지원할 수 있게 해주세요.`,
      campaign_form_commission_field_increase_max_step_option_step_2: (moneyText: string) => `${moneyText} 지원자까지 받아보기 (정말 잘하시는 분들이 어떤지 궁금하긴 해요.)`,
      campaign_form_commission_field_increase_max_step_option_step_1: (moneyText: string) => `${moneyText} 지원자까지 받아보기 (예산은 정해져 있지만 일단 받아볼게요.)`,
      campaign_form_commission_field_increase_max_step_option_step_0: `괜찮아요. (기대만큼 퀄리티가 안 나와도 받아들일게요.)`,
      campaign_form_single_day_posting_field_label: '12월 올영세일 전용 콘텐츠가 필요하신가요?',
      campaign_form_single_day_posting_field_check: '반드시 특정 날짜에 인스타그램에 업로드하고 싶습니다.',
      campaign_form_single_day_posting_field_check_comment: '가장 빠르게 진행 시, 모집 시작부터 최단 8일 소요\n\n포스팅 기한 내에 아무 때나 인스타그램에 업로드하는 것이 아니라\n특정 날짜를 지정하고, 반드시 그 날 인스타그램 업로드를 진행하고 싶습니다.',
      campaign_form_inspection_field_label: '사전 검수',
      campaign_form_inspection_field_check: '인스타그램에 릴스 업로드 전 사전 검수를 하고 싶습니다.',
      campaign_form_inspection_field_check_comment: '체크/해제 시 입력하신 날짜들이 초기화됩니다.',
      campaign_form_period_field_label: '캠페인 기간',
      campaign_form_period_field_oliveyoung_warning: (days: number) => `12월 올영세일 시작까지 ${days}일 남았습니다. (11월 30일 (일) ~ 12월 6일 (토))`,
      campaign_form_period_field_oliveyoung_calender_header: '12월 올영세일 : 11.30 (일) - 12.6 (토)',
      campaign_form_recruit_period_field_label: '인플루언서 모집 기간',
      campaign_form_recruit_period_required_select_starts_at: '모집 시작일을 먼저 선택해주세요.',
      campaign_form_recruit_period_required_select_ends_at: '모집 종료일을 먼저 선택해주세요.',
      campaign_form_selection_period_field_label: '인플루언서 선정 기간',
      campaign_form_selection_period_required_select_starts_at: '모델 선정 시작일을 먼저 선택해주세요.',
      campaign_form_product_deploy_period_field_label: '제품 출고 날짜',
      campaign_form_product_deploy_period_field_description: '출고일 미준수 시 인플루언서가 제작 거부를 할 수도 있으므로 신중히 골라주세요.',
      campaign_form_product_deploy_period_field_placeholder: '제품 출고일',
      campaign_form_posting_period_field_label: (category_id, isSingleDayPosting) => {
        switch(category_id){
          case CATEGORY_ID.BEAUTY:
            return isSingleDayPosting
              ? '릴스 제작 완료 및 인스타그램 포스팅 날짜'
              : '릴스 제작 완료 및 인스타그램 포스팅 기한';
          default:
            return '포스팅 제작 기한';
        }
      },
      campaign_form_posting_period_field_description: (category_id) => {
        switch(category_id){
          case CATEGORY_ID.BEAUTY:
            return null;
            // return <>DEPRECATED_퀄리티 높은 릴스를 위해 인플루언서가 최소 한 번의 주말은 보낼 수 있게 해주세요.<br /></>;
          default:
            return <>주말에 예쁜 곳을 방문하도록 최소 한 번의 주말은 포함해 주세요.<br /></>;
        }
      },
      campaign_form_posting_period_field_posting_ends_at_placeholder: (isSingleDayPosting) => {
        return isSingleDayPosting ? '릴스 제작 완료 및 인스타그램 포스팅 날짜' : '릴스 제작 완료 및 인스타그램 포스팅 기한';
      },
      campaign_form_inspection_period_field_label: '사전 검수 영상 제출 기한',
      campaign_form_inspection_period_field_label_1: '인플루언서의 ',
      campaign_form_inspection_period_field_label_2: '사전 검수 영상 ',
      campaign_form_inspection_period_field_label_3: '파일 ',
      campaign_form_inspection_period_field_label_4: '제출 기한',
      campaign_form_inspection_period_field_placeholder: '사전 검수 영상 제출 기한',

      campaign_form_inspection_feedback_period_field_label: '사전 검수 영상 피드백 기한',
      campaign_form_inspection_feedback_period_field_placeholder:'사전 검수 영상 피드백 기한',
      campaign_form_inspection_feedback_period_field_description: () => {
        return (
          <>  
            이 날 밤 12시까지 피드백을 남겨주셔야 하며,
            <br />
            기한을 초과하면 피드백 입력 화면이 자동으로 종료되므로 주의해 주세요.
          </>
        );
      },

      campaign_form_delivery_company_field_label: '이용 예정 택배사',
      campaign_form_output_type_field_label: '산출물 유형을 선택해주세요.',
      campaign_form_photo_guidelines_group_name: '사진 가이드라인',
      campaign_form_photo_guidelines_mandatory_photos_label: '필수 사진을 알려주세요.',
      campaign_form_photo_guidelines_mandatory_photos_description: '컨텐츠 생산 난이도가 높을수록 지원자 수가 줄어들 수 있습니다.',
      campaign_form_modification_guide: '인플루언서 모집 시작 전날까지는 캠페인 수정이 얼마든지 가능합니다.',
      campaign_form_cant_be_update_modal_title: '직접 수정할 수 없는 항목입니다.',
      campaign_form_cant_be_update_modal_text: '단톡방으로 문의주시면 바로 처리해 드립니다.',
      campaign_form_load_temporary_campaign_modal_title: '임시저장 내용 불러오기',
      campaign_form_load_temporary_campaign_modal_text: '이전에 임시저장했던 내용을 불러오겠습니까',
      campaign_form_load_temporary_campaign_modal_confirm: '불러오기',
      campaign_form_delete_product_confirm: '해당 제품을 삭제하시겠습니까?\r\n삭제된 제품은 복구할 수 없습니다.',
      campaign_form_is_after_recruit_start: '모집이 시작된 캠페인은 수정할 수 없습니다.',
      campaign_form_photo_model_limit_modal_title: '사진 최대 수량 제한',
      campaign_form_photo_model_limit_modal_text: (limit: number) => `사진은 ${limit}장을 넘을 수 없습니다.`,
      campaign_form_photo_model_recommended_modal_text: `필수 사진의 총 합은 4개가 적당합니다.\n사진 수가 늘어나면 인플루언서 참여율이 낮아집니다.`,
      campaign_form_other_requests_placeholder: '내용',
      campaign_form_partnership_code_field_label: '파트너십 광고 코드 발급',
      campaign_form_partnership_code_field_required_description: "릴스 제작 완료 후 ‘포스팅’ 메뉴에서 코드 확인이 가능합니다.",
      campaign_form_need_guideline_rule_field_true: '필요합니다.',
      campaign_form_need_guideline_rule_field_false: '필요 없습니다.',
      complete_title: (isUpdate?: boolean) => `${isUpdate ? '캠페인 수정이 완료되었습니다!' : '캠페인 생성이 완료되었습니다!'}`,
      complete_info_1: "인플루언서 모집 기간",
      complete_info_2: "인플루언서 선정 기간",
      complete_info_3: "증정할 제품 출고 날짜",
      complete_info_4: "인플루언서의 포스팅 제작 기간",
      complete_info_4_1: "인플루언서의 포스팅 제작 일자",
      create_modal_select_date: `제품 출고일을 선택해주세요.${"\n"}출고일을 기준으로 자동으로 포스팅 업로드 시작일과 종료일의 초기값이 입력됩니다.`,
      create_modal_postingEndsAt: (brandCategoryId) => {
        switch(brandCategoryId){
          case CATEGORY_ID.BEAUTY:
            return "릴스 업로드 종료일을 먼저 선택해주세요.";
          default:
            return "포스팅 업로드 종료일을 먼저 선택해주세요.";
        }
      },
      create_modal_recruit_immediately_title : '오늘부터 모집을 시작하시겠어요?',
      create_modal_recruit_immediately_text : <>
        모집 시작일을 ‘오늘’로 설정하면,<br/>
        캠페인 생성 완료 즉시 앱에 표출되어<br/>
        캠페인 내용 수정이 불가합니다.</>,
      create_delete_modal_success: "해당 제품을 성공적으로 삭제하였습니다.",
      create_delete_image_confirm: "해당 이미지를 삭제하시겠습니까?",
      create_next_step_with_saving: "임시저장 후 다음으로",
      create_step3_a_title: "반품 관련 정보",
      create_step3_a_manager_name: "담당자명",
      create_step3_a_manager_name_placeholder: "담당자명을 입력해 주세요.",
      create_step3_a_manager_phone: "휴대폰",
      create_step3_a_manager_phone_placeholder: "연락처를 입력해 주세요.",
      create_step3_a_manager_position: "직책",
      create_step3_a_manager_position_placeholder: "직책을 입력해 주세요.",
      create_step3_a_desc: "잘못된 제품이 배송된 경우 반품 받으실 정보를 입력해 주세요.",
      create_step3_a_return_addr: "반품 받으실 주소",
      create_step3_a_return_addr_placeholder: "주소를 정확하게 입력해주세요.",
      create_step3_b_title: "브랜드 담당자 정보",
      create_step3_b_desc: "캠페인 및 릴스 제작 상황 등을 공유드립니다.",
      create_step3_b_notice: <>
        사전 검수는 검수 기한이 지나면 피드백을 남기는 화면이 자동으로 종료됩니다.
        <br />
        따라서 기한을 놓치지 않도록 알림을 받는 것이 매우 중요합니다.
        <br />
        <br />
        반드시 본 캠페인과 관련된 모든 담당자 정보를 입력해 주세요.
      </>,
      create_step3_b_add_manager: "담당자 추가 +",
      create_step3_b_reels: "DEPRECATED_릴스 파일을 받을 이메일",
      create_step3_b_reels_desc: "DEPRECATED_릴스 완성본을 이메일로 보내드립니다.",
      create_step3_b_manager_email: "DEPRECATED_이메일",
      create_step3_b_manager_email_placeholder: "DEPRECATED_담당자의 이메일을 입력해주세요.",
      create_step3_a_wholesale_manager_name: "사장님 성함",
      create_step3_a_wholesale_manager_phone: "휴대폰",
      create_step3_a_wholesale_manager_name_placeholder: "사장님 성함을 입력해주세요.",
      create_step3_b_wholesale_title: "사장님 정보",
      create_step3_a_wholesale_select_manager: "DEPRECATD_사장님",
      create_step3_has_inspection_due_dt_modal_tile: <>사전 검수 관련 알림을 받을<br />모든 담당자 정보를 입력하셨나요?</>,
      create_step3_has_inspection_due_dt_modal_notice: <>
        사전 검수는 검수 기한이 지나면
        <br />
        피드백을 남기는 화면이 자동으로 종료됩니다.
        <br />
        <br />
        따라서 기한을 놓치지 않도록<br />
        알림을 받는 것이 매우 중요합니다.
        <br />
        <br />
        반드시 본 캠페인과 관련된<br />
        모든 담당자 정보를 입력해 주세요.
      </>,
      create_step3_has_inspection_due_dt_modal_cancel_button_text: "빠진 담당자가 있어요",
      create_step3_has_inspection_due_dt_modal_confirm_button_text: "전부 입력했어요",
      _create_payment_text21: (unit: string)=> `100건 시딩하면 건 당 3천${unit} 꼴`,
      create_payment_text22: "지금 결제하면 7일 무료 기간을 드립니다.",
      _create_payment_text23: (days) => (
        <>
          {days}일 뒤에 자동결제 되고, <br />
          원하는 때 자동결제 취소 가능합니다.,
        </>
      ),
      create_payment_text24: "자동결제 후 환불이 불가합니다.",
      create_payment_button_1: "무제한 이용해보기",
      create_payment_button_2: "그냥 이대로 진행하기",
      _create_payment_text31: (days)=> `무제한 이용권 이용 시 ${days}일 뒤 자동결제가 진행됩니다.`,
      create_payment_text32: "언제든 취소 가능하고, 결제 후 환불은 불가합니다.",
      create_stepTwo_text37: `*카페 실내 촬영도 금지됩니다`,
      show_alert_modal_temp_save_fail_title: "임시저장 실패",
      open_example_guideline_button_text: "다른 브랜드의 가이드라인 예시 보기",
      create_discount_message: "(예) 자사몰에서 신상 10% 할인중",
      create_prohibitions_check_1: "2. 금지사항이 필요한 경우 체크해 주세요.",
      create_prohibitions_check_2: "3. 금지사항이 필요한 경우 체크해 주세요.",
      create_photo_form_image_guideline: "4. 브랜드에서 추가 할 이미지 가이드가 있다면 넣어주세요. (선택)",
      create_photo_form_image_guideline_fashion: "입력하신 이미지는 모델들에게 표출되고, 동의를 받습니다.",
      create_text_guidelines: "문구 가이드라인",
      create_mandatory_phrases_prompt: "5. 포스팅에 꼭 들어가야할 필수 문구가 있다면 알려주세요",
      create_mandatory_phrases_description: "입력하신 메세지는 모델에게 표출됩니다.",
      create_tag_guidelines: "태그 가이드라인",
      create_brand_instagram_prompt: "6. 브랜드의 인스타그램 @공식계정을 알려주세요.",
      create_other_brand_tags_prompt: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "7. SNS에 릴스 업로드 시, 타 브랜드 태그가 들어가도 되나요?";
        default:
        return "7. 포스팅에 타 브랜드 태그가 들어가도 되나요?";
        }
      },
      create_sns_tags_prompt: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "8. SNS에 릴스 업로드 시, 함께 삽입될 #태그를 알려주세요.";
        default:
        return "8. SNS 포스팅 시, 함께 삽입될 #태그를 알려주세요.";
        }
      },
      create_hashtag_location_prompt: "9. 브랜드 해시태그가 들어갈 위치를 선택해 주세요.",
      create_advertisement_tag: "10. #광고 #협찬 태그",
      create_reels_form_guideline: "영상 가이드라인 설정",
      create_reels_form_text_guideline: "문구 가이드라인",
      create_reels_form_tag_guideline: "태그 설정",
      create_reels_form_additional_photos: "릴스 외 추가 사진 받기",
      create_reels_form_video_guideline: "영상 가이드라인을 알려주세요.",
      create_reels_form_image_guideline: "이미지 형식의 추가 가이드라인 (선택)",
      create_reels_form_image_guideline_fashion: "입력하신 이미지는 모델들에게 표출되고, 동의를 받습니다.",
      create_reels_form_image_guideline_beauty: "PPT, PDF 캡쳐본 및 깨알 같은 텍스트가 들어가 있는 이미지는 업로드하지 마세요.\n위반 시 검수팀이 무조건 가이드라인 수정을 요청합니다.",
      create_reels_form_image_guideline_beauty_modal_title: "PPT, PDF 캡쳐본 업로드 절대 금지",
      create_reels_form_image_guideline_beauty_modal_description: "PPT, PDF 캡쳐본 및 깨알 같은 텍스트가\n들어가 있는 이미지는 업로드하지 마세요.\n\n위반 시 검수팀이 무조건 가이드라인 수정을\n요청합니다.",
      create_reels_form_image_upload : '이미지와 설명 업로드 +',
      create_reels_form_image_modify : '이미지 교체하기',
      create_reels_form_logo_guideline: "브랜드 로고 파일 최대 2개 (선택)",
      create_reels_form_logo_guideline_desc: <>로고 파일이 없으면 인플루언서가 엉뚱한 폰트로 브랜드명을 타이핑합니다.<br/>화이트 로고를 강력히 권장하고, 블랙(컬러) 로고도 함께 올려주시면 더욱 좋습니다.</>,
      create_reels_form_logo_guideline_upload: "배경이 투명한 로고 파일 업로드 +",
      create_reels_form_emblem_oliveyoung_guideline: "올영세일 엠블럼",
      create_reels_form_emblem_guideline_check: `영상에 삽입되었으면 좋겠습니다.`,
      create_reels_form_emblem_guideline_desc: <>인플루언서가 둘 중 영상에 어울리는 엠블럼을 사용합니다.</>,
      create_reels_form_emblem_guideline_upload: "배경이 투명한 엠블럼 파일 업로드 +",
      create_reels_form_at_tag: "브랜드의 인스타그램 공식 계정",
      create_reels_form_hash_tag: '포스팅 시 삽입할 #태그',
      create_reels_form_additional_photos_2: "릴스 외 사진도 필요하신가요?",
      create_reels_form_placeholder_video_guideline: "매우 구체적이고 직관적으로 표현해주세요.",
      create_reels_form_placeholder_at_tag: "@brand_tag",
      create_reels_form_placeholder_hash_tag: "'#' 제외하고 글자만 입력해주세요.",
      create_reels_form_checkbox_no_additional_photos: "필요 없습니다.",
      create_reels_form_checkbox_additional_photos: "추가 사진이 필요합니다.\n(추가 사진을 요청할수록 난이도가 높아져 지원율에 영향을 미칠 수 있습니다. 최대 3장의 사진을 요청할 수 있습니다.)",
      create_reels_form_preferred_video_type: "선호하는 영상 유형",
      create_reels_form_preferred_video_type_desc: "캠페인명이 아래와 같이 보여지며,\n해당 유형의 인플루언서가 빠르게 모집됩니다.",
      create_reels_form_reference: "인플루언서에게 전달할 참고 릴스 URL 1개 (선택)",
      create_reels_form_reference_description: "*릴스 생산을 위한 참고 목적의 영상입니다.",
      create_reels_form_reference_description_title : '위 릴스에서 특별히 참고했으면 하는 점이 있나요? (선택)',
      create_reels_form_reference_description_desc : <>어디까지나 참고용이기에 인플루언서에게 강제할 수는 없지만,<br/>구체적으로 기입할수록 원하는 결과물을 얻을 확률은 높아집니다.</>,
      create_reels_form_prohibition_beauty_title : `${getServiceName()} 필수 가이드라인`,
      create_reels_form_prohibition_beauty_desc : `인플루언서에게 항상 전달되는 글로브의 필수 가이드라인입니다.`,
      create_reels_form_video_duration : '영상 최소 길이',
      create_reels_form_outputs : '필수 장면',
      create_reels_form_subtitle : '자막 내용 입력',
      create_reels_form_subtitle_opening_placeholder : '(예) 올리브영 품절 대란템',
      create_reels_form_subtitle_middle_placeholder : '(예) 항산화 성분이 많은 녹차 추출물 사용',
      create_reels_form_subtitle_closing_desc : '이 내용은 자막보다는 포스팅 글 내용으로 입력해 주시면 좋습니다.',
      create_reels_form_subtitle_closing_placeholder : '(예) 올리브영에서 30% 할인 중',
      create_reels_form_contents: "포스팅 글 내용 입력",
      create_reels_form_video_clean_title : "클린본 요청",
      create_reels_form_video_clean_download_desc : "릴스 제작 완료 후 ‘포스팅’ 메뉴에서 무료로 클린본 다운로드가 가능합니다.",
      create_reels_form_video_clean_price_desc : "deprecated_마음에 드는 영상만 선택적으로 다운로드 가능하며, 건 당 10만원이 청구됩니다.",
      create_reels_form_co_author_title : "공동 작업자 추가",
      create_reels_form_co_author_announcement_title : "중요 안내",
      create_reels_form_co_author_announcement_desc: `인플루언서가 인스타그램에 업로드했다고 해서
바로 공동 작업자로 표시되는 것이 아닙니다.

반드시 인플루언서의 공동 작업자 초대에
수락을 눌러주셔야 합니다.`,
      create_reels_form_co_author_desc : "인플루언서가 공동 작업자로 추가할 인스타그램 계정",
      create_reels_form_placeholder_co_author : '‘@’ 제외하고 텍스트만 입력',
      create_reels_form_load_contents_from_subtitles : '자막에 넣었던 내용 그대로 불러오기',
      create_reels_form_beauty_terms_title : '필수 동의 항목',
      create_reels_form_beauty_terms_agree : '아래 내용에 동의합니다.',
      create_reels_form_beauty_terms : <>가이드라인을 위반한 경우가 아니라면<br/>
      인플루언서에게 수정 요청을 할 수 없습니다.<br/>
      <br/>
      단, 사전 검수 기능을 이용하시는 경우에는<br/>
      재촬영을 제외한 자막, 폰트 등의 수정 요청이 가능합니다.<br/>
      <br/>
      브랜드의 피드백이 반영되었는지 글로브 검수팀에서 확인 후, 브랜드가 설정한 "릴스 제작 기한" 내 자유롭게 업로드하도록 요청합니다.<br/>
      <br/>
      따라서 의도하신 내용이 있는 경우 가이드라인에 잘 담아주시고,<br/>
      인플루언서 선정 시에는 평소 릴스 스타일 및 제작 역량을 꼭 확인해 주세요.</>,
      _create_max_length_indicator: (current:number, maximum:number)=>(
        `(${current}/${maximum} ${maximum}자 이내)`
      ),
      create_reels_form_warning_multiple_url: "참고 릴스 URL은 1개만 입력해 주세요.",
      create_reels_form_warning_multiple_url_desc: "우리 브랜드가 기대하는 느낌을 가장 잘 표현한\n릴스 URL을 1개만 입력해 주세요.",
      create_reels_form_warning_document: "브랜드가 직접 제작한 가이드 문서는\n사용 안하시는게 좋아요.",
      create_reels_form_warning_document_desc: "글로브를 통해 가이드라인을 만들지 않고,\n브랜드 자체 가이드라인 문서를 업로드해 버리면\n\n경험 상, 인플루언서 지원율이 30% 감소하고,\n릴스 제작 시 문제가 생길 가능성이 2배 높았습니다.",
      create_reels_form_warning_sns_injection: "참고 릴스는 1개로 충분해요.",
      create_reels_form_warning_sns_injection_desc: "참고 릴스를 2개 이상 전달하시면,\n인플루언서가 오히려 혼란스러워 합니다.",
      create_reels_form_before_after_label_for_japan: "사용전/사용후 컷",
      intro_backup_modal_use_pc: `PC의 제품증정 탭을 통해${"\n"}개설해주시길 바랍니다`,
      intro_backup_text_1: "제품증정 캠페인🥕",
      _intro_backup_text_2: () => (
        <>
          👀 단 2만 원으로 <b> 직접 모델도 선정</b>,
          <br /> 월 30만 원으로 <b>무제한</b> 시딩이라고?
        </>
      ),
      _intro_backup_text_3: () => (
        <>
          모델에게 제품을 증정하고,
          <br /> 진짜 원하는
          <br /> SNS 포스팅을 만들어 보세요.
        </>
      ),
      intro_backup_text_4: "3분이면 개설 완료!",
      intro_backup_text_5: "제품 증정 캠페인 개설하기",
      _intro_backup_text_6: () => (
        <>
          제품 증정 캠페인, <br />
          어떻게 진행되나요?
        </>
      ),
      intro_backup_text_7: "*기본요금: 1개 당 2만 원 (무제한: 월 30만 원)",
      intro_backup_text_8: "제품 증정 캠페인 개설제품 증정 캠페인 개설",
      _intro_backup_text_9: () => (
        <>
          브랜드 마음에 쏙 드는, <br />
          고퀄리티 포스팅 업로드 완료!✨
        </>
      ),
      intro_backup_text_10: "모델 지원",
      intro_backup_text_11: `${getServiceName()} 인플루언서`,
      intro_backup_text_12: "가장 마음에 드는 모델 선정",
      intro_backup_text_13: "포스팅 제작",
      intro_backup_text_14: `${getServiceName()} 인플루언서`,
      intro_backup_text_15: "인플루언서 컨텍, 어려우셨죠?",
      _intro_backup_text_16: () => (
        <>
          <b className="text-[#ED8E00]">1,500명</b>의 인플루언서,
          <br className="hidden md:flex" /> 저희가 모아드립니다
        </>
      ),
      intro_backup_text_17: "다양한 사진 여러 장과 릴스도 촬영할게요!",
      intro_backup_text_18: "저는 게시물 5장 + 릴스도 촬영할 수 있어요!",
      intro_backup_text_19: "저 이번에 파리 여행 가는데, 에펠탑 앞에서 찍을게요!",
      intro_backup_text_20: "지루한 포스팅 1개는 이제 그만.",
      _intro_backup_text_21: () => (
        <>
          모델들이 <br />
          <b className="text-[#ED8E00]">직접 어필</b>합니다
        </>
      ),
      intro_backup_text_22: "원하는 모델이 없다구요?",
      _intro_backup_text_23: () => (
        <>
          원하는 모델, <br />
          이젠 <b className="text-[#ED8E00]">선정만 하세요</b>
        </>
      ),
      _intro_backup_text_24: () => (
        <>
          지금 바로
          <br /> 캠페인을 개설해보세요!
        </>
      ),
      intro_backup_text_25: "3분이면 개설 완료!",
      intro_backup_text_26: "제품 증정 캠페인 개설하기",
      intro_text_3: "퀄리티 높은 컨텐츠를 만들어 드립니다.",
      intro_text_4: "소개서 다운받기",
      intro_text_5: "Check Point 1",
      intro_text_9: "1. SNS에서 잠재고객 확보",
      intro_text_10: "2. 고객들이 공감하여 구매전환율 상승",
      intro_text_11: "매출증가",
      intro_text_12: "Check Point 2",
      intro_text_13: "5분만에 끝나는 초간단 3스텝 시딩",
      intro_text_14: "시딩 업무를 모두 자동화 했습니다.",
      intro_text_15: "Check Point 3",
      intro_text_16: "제작된 컨텐츠 무신사 스냅 등에 ",
      intro_text_17: "무제한 2차 활용",
      intro_text_18: "무신사 스냅, 광고, 자사몰, 인스타그램 등 ",
      intro_text_19: "원하는 곳에 자유롭게 사용",
      intro_text_20: "Check Point 4",
      intro_text_22: "페미닌/캐주얼/섹시글램/골프 등 ",
      intro_text_23: "다양한 스타일의 모델",
      intro_text_24: "Check Point 5",
      intro_text_25: "원하는 인플루언서 선택 가능",
      intro_text_26: "4천명의 모델 중 ",
      intro_text_27: "우리 브랜드 이미지에 맞는 모델 선택 가능",
      intro_text_28: "Check Point 6",
      intro_text_29: "정교한 가이드라인 설정 가능",
      intro_text_30: "포스팅의 만족도 상승",
      intro_text_31: "기존 자체 시딩과 한눈에 비교",
      _intro_text_32: (unit: string)=> `100건 진행 시 건 당 3천${unit}에 진행 가능`,
      intro_text_33: () => (
        <>
          모델에게 제품 증정해 주고
          <br />
          컨텐츠 만들어 보세요
        </>
      ),
      intro_text_34: () => (
        <>
          {`대형 패션 브랜드의 `}
          <br />
          {`높은 시딩 현황`}
        </>
      ),
      intro_text_35: () => (
        <>
          {`무신사 및 상위 20위 브랜드들은 `}
          <br className="flex md:hidden" />
          {`매달 100-300건 시딩을 합니다.`}
        </>
      ),
      intro_text_36: () => (
        <>
          {`5분 만에 끝나는 `}
          <br />
          {`기적의 제품증정 프로세스`}
        </>
      ),
      intro_text_37: `제품증정 시스템 극효율로 혁신화했습니다.`,
      intro_text_38: () => (
        <>
          {`4천명의 인플루언서와 `}
          <br />
          {`함께합니다`}
        </>
      ),
      intro_text_39: () => (
        <>
          {`페미닌/캐주얼/섹시글램/골프 등 `}
          <br className="flex md:hidden" />
          {`스타일이 다양합니다.`}
        </>
      ),
      intro_text_40: () => (
        <>
          {`내가 원하는 모델에게만 `}
          <br />
          {`제품을 증정하세요`}
        </>
      ),
      intro_text_41: () => (
        <>
          {`4천명의 모델 중 `}
          <br className="flex md:hidden" />
          {`우리 브랜드 이미지에 맞는 모델을 선택 가능합니다.`}
        </>
      ),
      intro_text_42: () => (
        <>
          {`정교한 가이드라인 `}
          <br />
          {`설정하세요`}
        </>
      ),
      intro_text_43: `브랜드가 직접 가이드라인을 설정할 수 있습니다.`,
      intro_text_44: () => (
        <>
          {`컨텐츠 2차 활용은`}
          <br />
          {`무제한 무료`}
        </>
      ),
      intro_text_45: () => (
        <>
          {`원하는 용도로 기간의 제한 없이 `}
          <br className="flex md:hidden" />
          {`무료로 이용할 수 있습니다.`}
        </>
      ),
      intro_text_46: () => (
        <>
          {`400+개`}
          <br />
          {`브랜드가 이용 중`}
        </>
      ),
      intro_text_47: `높은 만족도로 매우 낮은 이탈율을 보이고 있습니다.`,
      payments_bills_text_1: "자동결제 취소하기",
      _payments_cancel_complete_text_1: () => (
        <>
          제품 증정 무제한 이용권
          <br />
          자동 결제가 취소되었습니다.
        </>
      ),
      _payments_cancel_complete_text_2: () => (
        <>
          제품 증정 무제한 이용권을 다시 구입하고 싶다면,
          <br />
          <b>상단 메뉴[제품 증정]</b>을 눌러 이용해주세요.
        </>
      ),
      _payments_cancel_confirm_text_1: (over_days: number, last_date: string) => (
        <>
          {`현재 만들어진 캠페인이 시딩 패스 이용기간을 `}
          {over_days}일 초과하므로,
          <br />
          {over_days}일치 대금을 더 결제하고 취소를 진행합니다.
          <br />
          <br />
          취소 시 {last_date}
          까지 사용이 가능합니다.
          <br />
        </>
      ),
      _payments_cancel_confirm_text_2: (date: string) => (
        <>
          취소 시 {date}
          까지 사용이 가능합니다.
        </>
      ),
      payments_cancel_confirm_text_3: "자동결제 취소하기",
      _payments_cancel_confirm_text_4: (unit: string) => (
        <>
          DEPRECATED_자동결제를 취소하면, 이용권 만료일로부터 제품 제공 이용 시 <br />
          제품 갯수 당 20,000{unit}이 부과됩니다.
        </>
      ),
      _payments_cancel_confirm_text_5: () => (
        <>
          향후 캠페인 생성 시 포스팅 기한 날짜가 이 날짜를 초과할 수 <br />
          없습니다.
        </>
      ),
      payments_cancel_confirm_text_6: "이대로 유지하기",
      payments_cancel_confirm_text_7: "자동결제 취소하기",
      payments_text_1: "결제 내역이 없습니다.",
      _payments_text_2: (date: number, days: number) => <>{date}일에 {days}일 뒤 자동결제에 대한 동의를 하셨습니다. 결제 후 환불이 불가합니다.</>,
      payments_text_3: "구매 분류",
      payments_text_4: `한달의 이용기간은 "첫 캠페인 생성일 ~ 마지막 캠페인의포스팅기한"까지 입니다.`,
      select_text_1: "제품을 증정할 모델을 선택해주세요.",
      _select_text_2: (n: number) => `최대 ${n}명의 모델을 선택하실 수 있습니다.`,
      select_text_3: "요청이 진행중입니다.",
      select_text_4: "모델 선정이 완료되었습니다.",
      select_text_5: <>선정된 모델에게 제품을 보내고<br/>운송장 번호를 입력해 주세요.</>,
      select_text_6: "선택 완료 후 변경이 불가하니 신중하게 골라주세요.",
      select_text_7: "선택 완료하기",
      show_text_1: "최신순",
      show_text_2: "평점순",
      show_text_3: "팔로워순",
      show_text_4: "라이크순",
      show_text_5: "선정한 인플루언서",
      show_text_6: "지원한 인플루언서",
      show_text_7: "캠페인 전체보기",
      show_text_8: "제품증정 포스팅 가이드라인",
      show_text_9: "제품증정 릴스 가이드라인",
      show_text_10: "캠페인 수정하기",
      show_text_11: "캠페인 삭제를 원하시면 단톡방으로 문의주세요.",
      show_text_12: "포스팅 가이드라인",
      show_text_13: "포스팅에 들어가야할 필수 문구",
      show_text_14: "릴스에 들어가야 할 필수 문구",
      _show_text_17: () => `*머리와 발끝이 잘리지 않은 사진이 필수로 1컷 이상${"\n"}*앉은 자세는 불가하고 정면으로 서서 ${"\n"}*미포함시 ‘포스팅 안함’으로 간주됩니다.`,
      show_text_18: "제품 증정 수 변경",
      show_text_19: "* 모델 선정 완료 전에만 제품 증정 수 변경이 가능합니다.",
      show_text_20: "인플루언서 모집 기간",
      show_text_21: "인플루언서 선정 기간",
      show_text_22: "증정할 제품 출고 날짜",
      show_text_23: "인플루언서의 포스팅 제작 기간",
      show_text_23_1: "인스타그램 업로드 날짜",
      show_text_24: "지금 모집 종료하고 바로 모델 선택하기",
      show_text_25: "택배사",
      show_text_26: "태그",
      show_text_27: "브랜드 계정 태그",
      show_text_28: "우리 제품을 증정 받아본 적 없는 인플루언서만 보기",
      show_text_29: "찜한 인플루언서만 보기",
      show_text_30: "최신순",
      show_text_31: "평점순",
      show_text_32: "팔로워순",
      show_text_33: "라이크순",
      show_text_34: "누적선정순",
      show_text_35: "찜순",
      show_text_36: "모델 모집 기간이 아닙니다.",
      _show_text_37: (count: number) => `지원 한 모델 수 : ${count}`,
      show_text_38: "검색 조건을 변경해주세요.",
      show_text_39: "포스팅 업로드 기간이 아닙니다.",
      show_text_40: "선정할 모델을 선택해주세요.",
      show_text_41: "모델 선정하기",
      _show_text_42: () => (
        <>
          1. 모델 선정을 완료하면 취소할 수 없습니다.
          <br /> <br /> 2. 선택한 모델에게는 반드시 제품을 배송해야합니다.
          <br /> <br /> 3. 배송일이 늦어지는 경우 포스팅 기한도 함께 늘어납니다.
        </>
      ),
      show_text_43: "모델 선정 진행하기",
      show_text_44: "엑셀 출력하기",
      _show_text_45: () => (
        <>
          선택 완료 후 변경이 불가하니 <br className="md:hidden" />
          신중하게 골라주세요.
        </>
      ),
      show_text_52: "값을 입력해주세요.",
      show_text_59: "기타 필수 전달사항 입력 (선택)",
      show_text_62: "복사하기",
      show_text_68: "가이드라인 보기",
      show_text_70: "오늘",
      _show_text_71: (diffDay: any, type: any) => (type === 1 ? -diffDay + "일 남음" : diffDay + "일 지남"),
      _show_text_72: (deplayAt, offsetText) => <>{`출고 예정일: ${deplayAt} (${offsetText})`}</>,
      show_text_73: "** 잘못된 출고일자 데이터 **",
      show_text_76: `감도 높은 ${getServiceName()} 추천 모델만 보기`,
      show_text_77: "모집기간 일주일 연장하기",
      show_text_78: "엠베서더 선정순",
      show_text_79: "브랜드 재선택순",
      _show_text_80: () => (
        <>
          제품 대여 서비스를 이용하는 모델이<br/>
          현재 몇 개의 브랜드에서 엠베서더 모델로 활동 중인 지를 나타내는 지표입니다.<br/>
          다수의 브랜드로부터 검증받은 모델과의 협업으로 보다 만족스러운 콘텐츠를 받아보세요!
      </>
      ),
      _show_text_81: () => (
        <>
          제품 증정 서비스를 이용하는 모델이<br/>
          특정 브랜드로부터 제품 증정을 2회 이상 받아본 횟수가 몇 번인 지를 나타내는 지표입니다.<br/>
          여러 브랜드에서 반복적으로 증정을 받은 신뢰성 있는 모델과의 협업으로 보다 만족스러운 콘텐츠를 받아보세요!
        </>
      ),
      show_text_82: `카테고리 필터`,
      show_text_83: `우리 브랜드의 카테고리와 맞지 않는 모델`,
      _show_text_84: (categoriesText) => `${categoriesText} 카테고리 전문 모델을 제외합니다.`,
      show_text_85: `해당하는 모델이 없습니다.`,
      show_text_86: `활성도순`,
      _show_text_87: () => (
        <>
          최근 {getServiceName()} 앱 활동 내역이 있는 모델을 우선하여 보여줍니다.
        </>
      ),
      show_text_89: `강력 추천!`,
      show_text_90: `추천 인플루언서`,
      show_text_91: `뷰티 릴스 제작 역량이 뛰어난 검증된 인플루언서입니다.`,
      show_text_92: `일반 인플루언서`,
      show_text_93: `화장품을 들고 사진을 잘 찍는 것은 매우 쉽습니다. 반드시 릴스 제작 경험 및 역량이 있는 지를 확인해 주세요.`,
      show_text_94: `릴스 작업물을 반드시 확인해 주세요.`,
      show_text_95: `찜한 인플루언서`,
      show_text_96: `찜한 인플루언서 전부 선정하기`,
      _show_text_97: () => `추가 결제가 필요합니다.`,
      _show_text_99: () => `확인 버튼을 누르시면\n추가 결제 화면으로 이동합니다.`,
      show_text_100: `선정 인원 수 변경하기`,
      show_text_101: `선정 인원 수를 줄이려면\n고객센터로 연락 부탁드립니다.`,
      show_text_102: `결제 시스템 제공 업체의 기능적 한계로 인해\n선정 인원 수를 줄이려면 개발팀이\n직접 캠페인을 삭제 후 재생성해야 하는\n번거로운 과정을 거쳐야 합니다.\n\n이러한 이유 때문에, 많이 불편하시겠지만\n고객센터로 연락을 부탁드리겠습니다.`,
      show_text_103: "모집 마감까지",
      show_text_104: "지금 모집 종료하고 바로 선정 단계로 넘어가기",
      show_text_105: `사전 검수 영상 제출 기한`,
      show_text_107: "참고할 릴스 예시 설명",
      show_text_108: `복구할 수 없습니다.\n정말로 삭제합니까?`,
      show_text_109: `원고료 상향 지원한 추천 인플루언서`,
      show_text_110: `사전 검수 영상 피드백 기한`,
      _show_text_110: (moneyText:string) => `평소에 ${moneyText}보다 더 높은 원고료의 캠페인에 참여해온 인플루언서입니다.`,
      show_text_brand_liked_influencers: "저장해둔 인플루언서",
      show_text_brand_with_product_liked_influencers: "찜한 인플루언서",
      show_text_brand_never_selected_influencers: "선정한 적 없는 인플루언서",
      show_text_brand_previously_selected_influencers: "선정한 적 있는 인플루언서",
      show_text_sort_by_brand_liked_influencers_date: "저장순",
      show_text_new_influencers: "신입 인플루언서",
      update_text_1: "지금 모집 종료하고 바로 모델 선택하기",
      update_text_2: "모집 종료되는 제품",
      update_text_3: "증정할 제품 출고 날짜",
      _update_text_4: () => (
        <>
          증정하려는 제품을 출고할 날짜를 선택해 주세요.
          <br />
          출고 날짜에 제품 미발송 시, 브랜드 경험 불만족으로 이어질 수 있으며
          <br />
          포스팅 기한이 연장될 수 있습니다.
        </>
      ),
      update_text_5: "제품 출고일",
      update_text_6: "포스팅 업로드 날짜",
      _update_text_7: () => (
        <>
          인플루언서가 포스팅을 업로드 하는 기간입니다.
          <br />
          인플루언서가 캠페인 지원 시 포스팅 업로드 날짜에 동의하고 지원한 것이기
          <br /> 때문에 이 날짜는 바꿀 수 없습니다.
        </>
      ),
      update_text_8: "포스팅 시작일",
      update_text_9: "포스팅 종료일",
      update_text_10: "완료하고 모델 선택하러 가기",
      extend_text_1 : '모집기간 일주일 연장하기',
      _extend_text_2: () => (
        <>
          인플루언서의 포스팅 제작 기간을 포함하여<br/>
          모든 기간이 일주일씩 연장됩니다.<br/>
          <br/>
          연장은 캠페인 당 한 번만 가능하며,<br/>
          연장 후 취소할 수 없습니다.<br/>
        </>
      ),
      extend_text_3 : '연장 후 인플루언서 모집 기간',
      extend_text_4 : '연장 후 인플루언서 선정 기간',
      extend_text_5 : '연장 후 증정할 제품 출고 날짜',
      extend_text_6 : '연장 후 인플루언서의 포스팅 제작 기간',
      extend_text_7 : '연장하기',
      _intro_common_text_1: () => (
        <>
          모델에게 제품 증정해 주고
          <br />
          컨텐츠 만들어 보세요
        </>
      ),
      intro_common_text_2: "퀄리티 높은 컨텐츠를 만들어 드립니다.",
      intro_common_text_3: "소개서 다운받기",
      intro_common_text_4: "시작하기",
      _intro_common_text_5: () => (
        <>
          {`대형 패션 브랜드의 `}
          <br />
          {`높은 시딩 현황`}
        </>
      ),
      _intro_common_text_6: () => (
        <>
          {`무신사 및 상위 20위 브랜드들은 `}
          <br className="flex md:hidden" />
          {`매달 100-300건 시딩을 합니다.`}
        </>
      ),
      _intro_common_text_7: () => (
        <>
          {`5분 만에 끝나는 `}
          <br />
          {`기적의 제품증정 프로세스`}
        </>
      ),
      intro_common_text_8: "제품증정 시스템 극효율로 혁신화했습니다.",
      _intro_common_text_9: () => (
        <>
          {`4천명의 인플루언서와 `}
          <br />
          {`함께합니다`}
        </>
      ),
      _intro_common_text_10: () => (
        <>
          {`페미닌/캐주얼/섹시글램/골프 등 `}
          <br className="flex md:hidden" />
          {`스타일이 다양합니다.`}
        </>
      ),
      _intro_common_text_11: () => (
        <>
          {`내가 원하는 모델에게만 `}
          <br />
          {`제품을 증정하세요`}
        </>
      ),
      _intro_common_text_12: () => (
        <>
          {`4천명의 모델 중 `}
          <br className="flex md:hidden" />
          {`우리 브랜드 이미지에 맞는 모델을 선택 가능합니다.`}
        </>
      ),
      _intro_common_text_13: () => (
        <>
          {`정교한 가이드라인 `}
          <br />
          {`설정하세요`}
        </>
      ),
      intro_common_text_14: "브랜드가 직접 가이드라인을 설정할 수 있습니다.",
      _intro_common_text_15: () => (
        <>
          {`컨텐츠 2차 활용은`}
          <br />
          {`무제한 무료`}
        </>
      ),
      _intro_common_text_16: () => (
        <>
          {`원하는 용도로 기간의 제한 없이 `}
          <br className="flex md:hidden" />
          {`무료로 이용할 수 있습니다.`}
        </>
      ),
      _intro_common_text_17: () => (
        <>
          {`400+개`}
          <br />
          {`브랜드가 이용 중`}
        </>
      ),
      intro_common_text_18: "높은 만족도로 매우 낮은 이탈율을 보이고 있습니다.",
      intro_common_text_19: "소개서 다운받기",
      intro_common_text_20: "시작하기",
      _intro_wholesale_text_1: () => (
        <>
          {`인플루언서 사진으로 신상마켓 `}
          <br className="flex md:hidden" />
          {`꾸미고 `}
          <br className="hidden md:flex" />
          {`매출 확 올려보세요`}
        </>
      ),
      intro_wholesale_text_2: "인플루언서 컨텐츠 제작 대행 서비스",
      intro_wholesale_text_3: "룩북 감상하기",
      intro_wholesale_text_4: "시작하기",
      _intro_wholesale_text_5: () => (
        <>
          {`신상마켓에 이런 사진 올리면`}
          <br />
          {`매출 당연히 안나오죠`}
        </>
      ),
      intro_wholesale_text_6: "사진 퀄리티로 경쟁력을 갖출 필요가 있습니다.",
      _intro_wholesale_text_7: () => (
        <>
          {`인플루언서가 사장님네 옷을 입고`}
          <br />
          {`사진을 찍어드립니다`}
        </>
      ),
      intro_wholesale_text_8: "신상마켓에 사용해서 매출 확 올려보세요.",
      _intro_wholesale_text_9: () => (
        <>
          {`신상마켓에 활용해서`}
          <br />
          {`매출 올리세요`}
        </>
      ),
      intro_wholesale_text_10: "신상마켓에 사용해서 매출 확 올려보세요.",
      _intro_wholesale_text_11: () => (
        <>
          {`5분만에 끝나는`}
          <br />
          {`초간단 3스텝 제품증정`}
        </>
      ),
      intro_wholesale_text_12: "제품증정 시스템 극효율로 혁신했습니다.",
      _intro_wholesale_text_13: () => (
        <>
          {`4천명의 인플루언서와 `}
          <br />
          {`함께합니다`}
        </>
      ),
      _intro_wholesale_text_14: () => (
        <>
          {`페미닌/캐주얼/섹시글램/골프 등 `}
          <br className="flex md:hidden" />
          {`스타일이 다양합니다.`}
        </>
      ),
      _intro_wholesale_text_15: () => (
        <>
          {`내가 원하는 모델에게만 `}
          <br />
          {`제품을 증정하세요`}
        </>
      ),
      _intro_wholesale_text_16: () => (
        <>
          {`4천명의 모델 중 `}
          <br className="flex md:hidden" />
          {`우리 브랜드 이미지에 맞는 모델을 선택 가능합니다.`}
        </>
      ),
      _intro_wholesale_text_17: () => (
        <>
          {`정교한 가이드라인 `}
          <br />
          {`설정하세요`}
        </>
      ),
      intro_wholesale_text_18: "브랜드가 직접 가이드라인을 설정할 수 있습니다.",
      _intro_wholesale_text_19: () => (
        <>
          {`언제든 무료로`}
          <br />
          {`원본 다운로드 가능`}
        </>
      ),
      _intro_wholesale_text_20: () => (
        <>
          {`브랜드 관리자 페이지에서 `}
          <br className="flex md:hidden" />
          {`언제든 원본 다운로드가 가능합니다.`}
        </>
      ),
      _intro_wholesale_text_21: (unit: string) => (
        <>
          {`100건 진행 시`}
          <br />
          {`건 당 3천${unit}에 제작 가능`}
        </>
      ),
      intro_wholesale_text_22: "원하시는 요금제로 진행하실 수 있습니다.",
      intro_wholesale_text_23: "룩북 감상하기",
      intro_wholesale_text_24: "시작하기",
      store_contact_msg: "증정 + 수수료 이용 문의"
      ,
      apply_commission_modal_quantity_unit : '개',
      apply_commission_modal_text_1 : '현금을 증정하고',
      apply_commission_modal_text_2 : '더 좋은 모델을 모집합니다.',
      apply_commission_modal_text_3 : '수량',
      apply_commission_modal_text_4 : '원고료',
      _apply_commission_modal_text_5 : (unit: string) => `* 릴스, 티셔츠, 속옷의 경우 최소 5만${unit}을 권장합니다.`,
      apply_commission_modal_text_6 : '* 결제 후 원하는 모델이 모집되지 않는 경우 즉시 환불해 드립니다.',
      apply_commission_modal_text_7 : '지금 결제하기',
      _apply_commission_modal_text_8 : (unit: string) => unit,
      apply_commission_modal_text_9 : '총 결제금액',
      _select_commission_label: (commissionPrice:number, currencySuffix:string) => {
        return `${commissionPrice / 10000}만${currencySuffix}`
      },
      select_commission_reference_url_label: `레퍼런스 모음`,
      select_commission_options: (brand: SelectCommissionProps['brand'], currencySuffix: string) => {
        const commissionOptions = getCampaignCommissionOptions(brand);
        return commissionOptions.map((commissionOption) => {
          return {
            label: `${commissionOption.commission / 10000}만${currencySuffix}`,
            value: commissionOption.commission,
            maxStep: commissionOption.maxStep,
          }
        })
        
      },
      hidden_influencers_text : () => (<>현재 다른 캠페인의 기한 초과 이슈로 인해 신규 캠페인 지원이 불가능해져 <b>지원자 목록에서 제외된 인플루언서</b>가 있습니다.</>),
      only_this_campaign_liked_influencers_text : () => (<b>· 이 캠페인에서만 찜한 인플루언서 : </b>),
      saved_influencers_text : () => (<b>· 저장해둔 인플루언서: </b>),
      normal_influencers_desc : () => (
        <>
          {'작업물 별 퀄리티 기복이 크고, 기한 및 가이드라인 준수 여부가 검증되지 않은 인플루언서입니다.'}
          <br/>
          {'화장품을 들고 사진을 잘 찍는 것은 매우 쉽습니다. 반드시 릴스 제작 경험 및 역량이 있는 지를 확인해 주세요.'}
        </>
      ),
      brand_request_recruiting_campaign_application_btn_text: "우리 캠페인에 지원해 달라고 부탁하기",
      brand_request_recruiting_campaign_application_modal_success_title: "부탁하기 신청 완료",
      brand_request_recruiting_campaign_application_modal_success_text: "글로브 담당자가 곧 연락을 드리겠습니다.",
      brand_request_recruiting_campaign_application_modal_title: "모집 중인 캠페인에 지원 부탁하기",
      brand_request_recruiting_campaign_application_modal_text: (name) => `${name} 인플루언서가 우리 캠페인에 지원해주길 바라시나요?\n글로브가 중간에서 소통을 도와드리겠습니다.`,
      brand_request_recruiting_campaign_application_modal_phone_label: '담당자님의 휴대폰',  
    },
    cards: {
      create_types_1: "일반",
      create_types_2: "개인사업자",
      create_types_3: "법인개별",
      create_types_4: "법인공용",
      create_text_1: "카드 정보를 전부 입력해주세요.",
      create_text_2: "법인개별: 본인 이름이 기재돼 있습니다.",
      create_text_3: "법인공용: 회사명이 기재돼 있습니다.",
      create_text_4: "휴대폰",
      create_text_5: "카드번호",
      create_text_6: "유효기간 (MM/YY)",
      create_text_7: "비밀번호 앞 두자리",
      create_text_8: "사업자등록번호 10자리",
      create_text_9: "주민등록번호 앞 6자리",
      create_text_10: "카드 소유자 이름",
      create_text_11: "등록하기",
      create_text_12: "이메일",
      create_text_13: "카드번호가 올바르지 않습니다.",
      create_text_14: "유효기간이 올바르지 않습니다.",
      create_text_15: "보안코드가 올바르지 않습니다.",

      index_text_1: "등록된 카드가 없습니다.",
      index_text_2: "카드 등록하기",
      index_text_3: "결제 카드 변경하기",
      index_text_4: "결제 카드 등록하기"
    },
    charts: {
      approved_at_text_1: "모델들의 승인된 기간을 선택해주세요.",
      approved_at_text_2: "옷장에 담은 제품 수",
      _approved_at_text_3: (n: number | string) => `해당 사용자 수 : ${n}명`,
      _approved_at_text_4: (weeks: number) => `마지막으로 장바구니에 담은 주 (최대 ${weeks}주)`,
      approved_at_text_5: "대여한 제품 수",
      _approved_at_text_6: (n: number | string) => `해당 모델 수 : ${n}명`,
      _approved_at_text_7: (weeks: number) => `마지막으로 대여 신청한 주 (최대 ${weeks}주)`,
      approved_at_text_8: "대여하기 누른 수",
      approved_at_text_9: "총 현업 모델 수",
      approved_at_text_10: "1달간 1회라도 대여한 모델 수",
      approved_at_text_11: "2달간 1회라도 대여한 모델 수",
      approved_at_text_12: "3달간 1회라도 대여한 모델 수",
      _approved_at_text_13: (dateFrom: string, dateTo: string) => `${dateFrom} 부터 ${dateTo} 에`,
      approved_at_text_14: "승인된 모델들의활동 내역 통계",
      approved_at_text_15: "모델 승인 기간 선택",
      weekly_text_1: "1주차",
      weekly_text_2: "2주차",
      weekly_text_3: "3주차",
      weekly_text_4: "4주차",
      weekly_text_5: "5주차",
      weekly_text_6: "6주차",
      weekly_text_7: "7주차",
      weekly_text_8: "8주차",
      weekly_text_9: "9주차",
      weekly_text_10: "10주차",
      weekly_text_11: "차트 정보를 불러오는데 실패하였습니다.",
      _weekly_text_12: (weeks_ago: number, n: number | string) => `${weeks_ago}주 전 - ${n}명`,
      weekly_text_13: "옷장에 담은 수",
      _weekly_text_14: (weeks: number) => `모델승인후 ${weeks}주가 경과한 회원 수`,
      _weekly_text_15: (weeks: number) => `모든 모델의 초기 ${weeks}주간 모델 활동 차트`,
      weekly_text_16: "모델승인 후 경과 한 주"
    },
    emergency: {
      _products_filter_1: () => `전체
       `,
      _products_filter_2: () => `완료된${"\n"}것만 보기`,
      _products_filter_3: () => `완료${"\n"}안된것만 보기`,
      _products_filter_4: () => `추가된${"\n"}것만 보기`,
      _products_filter_5: () => `추가${"\n"}안된것만 보기`,
      products_text_1: "브랜드 - 포스팅",
      products_text_2: "사이즈 정보를 불러오는데 실패하였습니다.",
      products_text_3: "성공적으로 제품을 생성하였습니다.",
      products_text_4: "해당 제품 정보를 숨김 처리하시겠습니까?",
      products_text_5: "해당 제품이 숨김처리 되었습니다.",
      products_text_6: "해당 제품 정보를 수정하시겠습니까?",
      products_text_7: "성공적으로 해당 제품을 수정하였습니다.",
      products_text_8: "해당 제품 정보를 삭제하시겠습니까?",
      _products_text_9: (name: string) => `${name}이 삭제되었습니다.`,
      products_text_10: "물류 복구",
      products_text_11: "브랜드명",
      products_text_12: "제품정보",
      products_text_13: "숨김처리",
      _products_text_14: (count: number) => `조회된 대여 횟수 : ${count}회`,
      _products_text_15: (sizeName: number, qty: number) => (
        <>
          {`${sizeName} 사이즈 / `}
          {`${qty}벌`}
        </>
      ),
      products_text_16: "사이즈를 선택해주세요.",
      products_text_17: "수량을 선택해주세요.",
      rentals_text_1: "대여 목록",
      rentals_text_2: "회원명 검색"
    },
    help: {
      missions_1_title: "브랜드 정보 설정",
      missions_1_est: "1분 소요",
      missions_1_desc: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "브랜드의 로고를 업로드하고 릴스 업로드 시 삽입될 태그를 설정합니다.";
        default:
        return "브랜드의 로고를 업로드하고 포스팅 시 보여질 태그를 설정합니다.";
        }
      },
      missions_2_title: "포스팅 알림 설정",
      missions_2_est: "1분 소요",
      missions_2_desc: (category_id) => {
          switch(category_id){
          case CATEGORY_ID.BEAUTY:
          return "뉴스레터 및 릴스 제작 알림을 받을 연락처를 입력합니다.";
          default:
          return "뉴스레터 및 포스팅 알림을 받을 연락처를 입력합니다.";
          }
      },
      missions_3_title: "비밀번호 변경",
      missions_3_est: "30초 소요",
      missions_3_desc: "앞으로 사용할 비밀번호를 설정합니다.",
      missions_4_title: "제품증정 캠페인 만들기",
      missions_4_est: "5분 소요",
      missions_4_desc: "제품증정을 위해 제품정보 및 캠페인 정보를 등록합니다.",
      missions_text_1: "브랜드 정보를 불러올 수 없습니다.",
      missions_text_2: "반갑습니다, 처음 오셨나요?",
      _missions_text_3: () => (
        <>
          반갑습니다, 처음 오셨나요?
          <br />
          아래 필수 항목을
          <br className="md:hidden" />
          하나하나 진행해 주세요! 😀
        </>
      ),
      missions_text_4: "완료",
      missions_text_5: "바로가기",
      missions_text_6: "첫 이용 혜택",
      missions_text_7: "남음", // 시간. ex) 2 시간 남음
      missions_text_8: "이벤트가 마감 되었습니다!",
      _missions_text_9: () => <>위 시간 이내에 첫 캠페인을 만들면, 무제한 요금제 사용 시 7일의 무료 기간을 드립니다.</>,
      missions_text_10: "✅ 제품증정 캠페인 만들기 어렵지 않나요?",
      missions_text_11: "5분이면 끝!",
      missions_text_12: "캠페인 정보 입력",
      _missions_text_13: () => (
        <>
          캠페인 소개글 작성 및 제품 정보 등록
          <br />
          인플루언서 모집/선정 날짜 및 제품 출고 날짜 설정
        </>
      ),
      missions_text_15: "포스팅 가이드라인 설정",
      missions_text_16: "포스팅 #태그 설정",
      missions_text_17: "담당자 연락처 입력",
      missions_text_18: "결제",
      missions_text_19: "✅ 얼마나 많은 브랜드가 제품증정을 하고 있나요?",
      missions_text_20: "200+개 브랜드",
      _missions_text_21: () => (
        <>
          제품증정 서비스를 이용 중인 브랜드가 어느덧 200곳이 넘었습니다.
          <br />
          모든 브랜드가 가장 원했던 기능인 만큼 출시 한달만에 이뤄낸 성과입니다.
        </>
      )
    },
    image: {
      index_text_1: "이 이미지 다운로드"
    },
    invite: {
      intro_text_1: "오프라인 초청 문의",
      intro_text_2: "인플루언서를 초청해서",
      intro_text_3: `오프라인 매출 활성화 해보세요`,
      intro_text_4: `인플루언서가 오프라인에 방문하고 포스팅 할거에요.`,
      intro_text_5: "소개서 다운받기",
      intro_text_6: `${getServiceName()} 담당자에게 이용 문의하기`,
      _intro_text_7: () => (
        <>
          {`오프라인 행사`}
          <br />
          {`지인들만의 행사로 `}
          <br className="flex md:hidden" />
          {`진행되고 있나요?`}
        </>
      ),
      intro_text_8: `지인들에게 방문 요청하는 것은 한계가 있습니다.`,
      _intro_text_9: () => (
        <>
          {`방문 원하는 인플루언서를 `}
          <br />
          {`고르기만 해주세요.`}
        </>
      ),
      _intro_text_10: () => (
        <>
          {`지원한 인플루언서 중 `}
          <br className="flex md:hidden" />
          {`우리 행사와 맞는 사람을 골라주세요.`}
        </>
      ),
      _intro_text_11: () => (
        <>
          {`3분만에 `}
          <br />
          {`인플루언서 모집 시작`}
        </>
      ),
      intro_text_12: `빠르게 행사 참여 인원을 모집할 수 있어요.`,
      _intro_text_13: () => (
        <>
          {`오프라인 초청 `}
          <br />
          {`활성화의 효과`}
        </>
      ),
      intro_text_14: `10개 브랜드의 인터뷰 평균값입니다.`,

      intro_text_21: "소개서 다운받기",
      intro_text_22: `${getServiceName()} 담당자에게 이용 문의하기`,
      intro_text_23: "담당자를 배정 중입니다...",
      intro_text_24: "담당자 배정이 완료되었습니다.",
      intro_text_25: "오미경 팀장",
      _intro_text_26: (name: string) => (
        <>
          {name} 담당자님, 반갑습니다.
          <br />
          5분 이내로 전화드리겠습니다.
          <br />곧 만나요!
        </>
      )
    },
    lookbook: {
      _index_text_1: () => (
        <>
          {getServiceName()}에서 만든 사진
          <br />
          구경해 보세요
        </>
      )
    },
    models: {
      index_tabs_1: "전체",
      index_tabs_2: "밀어주는 모델",
      index_tabs_3: "제외한 모델",
      _index_text_1: (count: number | string) => `총 ${count}명의 모델`,
      index_text_2: "골프모델만 보기",
      index_text_3: "인기모델만 보기",
      index_text_4: "제외한 모델이 없어요.",
      index_text_5: "밀어주는 모델이 없어요.",
      index_text_6: "인기모델 보러가기",
      index_text_7: "밀어주기",
      index_text_8: "제외하기",
      index_text_9: "밀어주기 중",
      index_text_10: "제외하기 중",
      intro_text_1: "우리 브랜드와 잘 맞는",
      intro_text_2: "모델을 밀어주세요",
      intro_text_3: "밀어주는 모델이 우리 브랜드 옷을 입고",
      _intro_text_4: (unit: string) => `포스팅을 완료할 때마다 3만${unit}을 내주시면 됩니다`,
      intro_text_5: "모델 보러가기"
    },
    payments: {
      _complete_text_total_price: (price: number | string, amount: number) => `(1개당 ${price} * ${amount}개)`,
      complete_text_1: "화이트라벨",
      complete_text_2: "제품 증정 첫 이용",
      complete_text_3: "제품 증정 무제한",
      complete_text_4: "제품 증정",
      complete_text_5: "자사몰 연동 이용",
      complete_text_6: "개",
      complete_text_7: "건",
      complete_text_8: "갯수",
      complete_text_9: "비용",
      complete_text_10: "결제완료",
      _complete_text_11: (days: number) => `${days}일 뒤 자동결제에 동의하셨습니다.`,
      complete_text_12: "설치 비용",
      complete_text_13: "최초 1회만 결제",
      _complete_text_14: (date: string) => `(${date}일 에 결제가 진행됩니다.)`,
      _complete_text_15: (days: number) => `${days}일 뒤 자동결제 예정`,
      complete_text_16: "(VAT 10% 별도)",
      complete_text_17: "최종 결제금액 (VAT 10% 포함)",
      complete_text_18: "제품 증정 무제한 자동 결제 활성화",
      complete_text_19: "원고료 이용",
      complete_text_20: "자사몰 연동 이용권 자동 결제 활성화",
      complete_text_21: "건 당 요금제",
      complete_text_22: "1년 무제한 요금제",
      complete_text_23: "원고료",
      complete_text_24: "최종 결제금액 (VAT 10% 포함)",
      complete_text_25: "사전 검수 비용",
      complete_text_26: "결제가 성공적으로 완료되었습니다.",
      create_text_1: "화이트라벨",
      create_text_2: "제품 증정 첫 이용",
      create_text_3: "제품 증정 무제한",
      create_text_4: "제품 증정 무제한 자동 결제 활성화",
      create_text_5: "제품 증정",
      create_text_6: "자사몰 연동 이용",
      create_text_7: "자사몰 연동 이용권 자동 결제 활성화",
      create_text_8: "갯수",
      create_text_9: "비용",
      _create_text_10: (days: number) => `매 ${days}일 마다 자동결제`,
      _create_text_11: () => <>원하는 때 자동결제 취소 가능하고, 결제 후 환불이 불가합니다.</>,
      create_text_12: "무제한 요금제는 이용 도중 환불이 불가함에 동의합니다.",
      create_text_13: "결제가 진행중입니다.",
      create_text_14: "자동결제 진행에 동의 해주세요.",
      create_text_15: "결제 카드를 등록해주세요",
      create_text_16: "원고료 이용",
      create_text_17: "서비스 이용료",
      create_text_18: "제품 수량",
      create_text_19: "합계",
      create_text_20: "건 당 요금제",
      create_text_21: "1년 무제한 요금제",
      create_text_22: "매 증정 건 마다 서비스 이용료가 부과됩니다.",
      create_text_23: "1년 동안 서비스 이용료 없이 이용하실 수 있습니다.",
      create_text_24: "1달 동안 서비스 이용료 없이 이용하실 수 있습니다.",
      create_text_25: "무제한 요금제",
      create_text_26: "원고료",
      create_text_27: "사전 검수 비용",
      create_text_additional_selection_section_title: "추가 선정 비용",
      create_text_commission_increased_section_title: "원고료 상향 지원으로 인한 추가 비용",
      create_text_cash_brand_warning: "** 현금 결제 계정입니다. 실결제 없이 진행됩니다. **",
      create_text_clean_video_name: `클린본 파일`,
      create_text_clean_video_subtitle: `클린본 다운로드 비용`,
      create_text_clean_video_per_each: `영상 당`,
      create_text_clean_video_amount_name: `영상 수량`,
      create_text_additional: "추가 ",
      create_text_pass_using: "이용중",
      create_text_total_amount: (amount:number) => `총 ${amount.toLocaleString()}개`,
      create_text_per_each : "제품 당",
      index_text_1: "결제 내역이 없습니다.",
      index_text_2: "주문 일시",
      index_text_3: "상품",
      index_text_4: "결제 상태",
      index_text_5: "금액",
      index_text_6: "서비스 이용료",
      index_text_7: "원고료",
      index_text_8: "(VAT 포함 금액)",
      index_text_9: "사전 검수 비용",
      index_text_10: "원고료 상향"
    },
    postings: {
      index_duration_option_1: "협찬 신청",
      index_duration_option_2: "포스팅 생성",
      index_duration_1: "전체기간",
      index_duration_2: "최근 90일",
      index_duration_3: "최근 30일",
      index_duration_4: "최근 7일",
      index_duration_5: "이번 달",
      index_duration_6: "지난 달",
      index_duration_7: "이번 주",
      index_duration_8: "지난 주",
      index_text_1: "시작일을 입력해주세요",
      _index_text_2: (year: number, month: number) => `${year}년 ${month}월`,
      _index_text_3: (month: number) => `${month}월 완료된 대여 포스팅 수`,
      _index_text_4: (status1: any, status2: any) => `일반 포스팅 ${status1} + 엠베서더 포스팅 ${status2}`,
      _index_text_5: (month: number) => `${month}월 생성 중인 대여 포스팅 수`,
      _index_text_6: (month: number) => `${month}월 완료된 증정 포스팅 수`,
      _index_text_7: (month: number) => `${month}월 생성 중인 증정 포스팅 수`,
      index_text_9: "종료일 이전의 날짜를 선택해주세요.",
      index_text_10: "시작일 이후의 날짜를 선택해주세요.",
      index_text_11: "조회",
      index_text_12: "다운로드할 포스팅이 없습니다.",
      index_text_13: "50개 이하의 포스팅으로 제한됩니다.\n기간이나 조건을 제한해주세요.",
      index_text_14: "검색결과 사진만 일괄 다운로드",
      index_text_15: "님의 포스팅", // [name] 님의 포스팅
      _index_text_16: (keyword: string) => `"${keyword}"의 제품 검색 결과입니다.`,
      index_text_17: "의 포스팅", // [name] 의 포스팅
      _index_text_18: (keyword: string) => `"${keyword}"의 검색 결과`,
      index_text_19: "전체 포스팅",
      _index_text_20: (n: any) => `${n}개의 포스팅`,
      index_text_21: "포스팅 가이드라인",
      index_text_22: "알림 설정",
      index_text_23: "전체",
      index_text_24: "제품증정",
      index_text_25: "제품대여",
      index_text_26: "다른 브랜드의 포스팅 보기",
      index_text_27: "업데이트",
      index_text_28: "화이트라벨 기능 업데이트!",
      index_text_29: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "릴스가 만들어질 때 마다 알림을 받아보세요";
        default:
        return "포스팅이 만들어질 때 마다 알림을 받아보세요";
        }
      },
      modal_downloader_text_1: "에러가 발생했습니다.",
      modal_downloader_text_2: "다운로드할 포스팅이 없습니다.",
      _modal_downloader_text_3: (count: number) => `포스팅 수가 너무 많습니다. (${count}개)`,
      modal_downloader_text_4: `구분: 증정\n`,
      modal_downloader_text_5: `구분: 대여\n`,
      _modal_downloader_text_6: (date: string) => `시작일: ${date}\n`,
      _modal_downloader_text_7: (date: string) => `종료일: ${date}\n`,
      _modal_downloader_text_8: (name: string) => `모델명: ${name}\n`,
      _modal_downloader_text_9: (name: string) => `제품명: ${name}\n`,
      _modal_downloader_text_10: (name: string) => `제품명 상세검색: ${name}\n`,
      _modal_downloader_text_11: (name: string) => `제품명 검색: ${name}\n`,
      modal_downloader_text_12: "검색결과 사진만 일괄 다운로드",
      modal_downloader_text_13: "현재 검색 조건",
      modal_downloader_text_14: "- 대량의 이미지를 받습니다. 안정적인 네트워크 환경에서 시작해주세요.",
      modal_downloader_text_15: "- 50개를 초과하는 사진을 한번에 받는 것은 성능상 제한됩니다. 기간이나 조건을 제한해서 받아주세요.",
      modal_downloader_text_16: "이미지 데이터 요청 중...",
      _modal_downloader_text_17: (progress: string) => `이미지 다운로드 중... (${progress}%)`,
      modal_downloader_text_18: `생성 완료. 잠시만 기다려주세요...`,
      _modal_downloader_text_19: (progress: string) => `압축 파일 생성 중... (${progress}%)`,
      modal_downloader_text_20: "진행 중에는 취소할 수 없습니다"
    },
    products: {
      status_fl_desc_1: `제품정보 확인 후 이상이 없으면 [제출하기] 버튼을 눌러주세요.`,
      status_fl_desc_2: `입고 제품 검수 후 이상이 없으면 모델들에게 바로 대여가 시작됩니다.`,
      status_fl_desc_4: `오늘룩 모델들에게 정상적으로 대여가 진행 중입니다.`,
      status_fl_desc_5: `오늘룩이 반납요청을 확인할 때까지 조금만 기다려 주세요.`,
      status_fl_desc_6: `반납요청이 확인 완료되었습니다. 준비가 되면 제품을 보내드리겠습니다.`,
      status_fl_desc_7: `오늘룩이 반납 제품을 발송할 예정입니다. 곧 제품을 받으실 수 있습니다.`,
      status_fl_desc_8: `제품 반납이 완료되었습니다.`,

      recommand_search_option_1: "전체",
      recommand_search_option_2: "등록중",
      recommand_search_option_3: "등록완료",
      recommand_search_option_4: "입고중",
      recommand_search_option_5: "진행중",
      recommand_search_option_6: "반납요청",
      recommand_search_option_7: "반납요청접수",
      recommand_search_option_8: "반납중",
      recommand_search_option_9: "반납",
      recommand_text_1: "추가 입고를 고려해주세요",
      recommand_text_2: "제품 보내실 주소",
      recommand_text_3: "복사완료",
      recommand_text_4: "주소 복사가 완료되었습니다.",
      recommand_text_5: "복사실패",
      recommand_text_6: "주소 복사가 제한되었습니다.",
      recommand_text_7: "복사하기",
      recommand_text_8: "제품 인기순위",
      recommand_text_9: "클릭 수 ",
      recommand_text_10: "입고 수량 ",
      recommand_text_11: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층 (010-9635-9152)",
      create_master_text_1: "스타일 정보를 불러오는데 실패하였습니다.",
      create_master_text_2: "카테고리 정보를 불러오는데 실패하였습니다.",
      create_master_text_3: "재분류",
      create_master_text_4: "사이즈 정보를 불러오는데 실패하였습니다.",
      create_master_text_5: "제품정보 수정하기",
      create_master_text_6: "제품정보 입력하기",
      create_master_text_7: `해당 이미지를 삭제하시겠습니까?\r\n삭제된 이미지는 복구할 수 없습니다.`,
      create_master_text_8: "색상 삭제하기",
      create_master_text_8_m: "색상 삭제",
      create_master_text_9: "색상명을 입력해주세요.",
      create_master_text_10: "셋업의상인 경우 상의 색상으로 지정해주세요.",
      create_master_text_11: <>
      이 색상의
      <br/>
      대표 이미지
      </>,
      create_master_text_11_setup: <>
      대표 이미지
      </>,
      _create_master_text_12: () => (
        <>
          제품의 썸네일로 표현될 이미지를 업로드 해주세요.
          <br />
          정사각형이 아닌 경우 여백은 잘리게 됩니다.
          <br />
          용량은 5MB 이하인 이미지를 등록해 주세요.
        </>
      ),
      create_master_text_13: "수량을 선택해주세요.",
      create_master_text_14: "상위 카테고리를 먼저 선택해주세요.",
      create_master_text_15: "사이즈 삭제하기",
      create_master_text_15_m: "사이즈 삭제",
      create_master_text_16: "신발",
      create_master_text_17: "언더웨어",
      create_master_text_18: "모델을 선정할 때 해당 모델의 사이즈를 보여드립니다.",
      create_master_text_19: "선정한 모델의 사이즈에 맞추어 배송해주세요.",
      create_master_text_20: "이 색상의 다른 사이즈 추가하기 +",
      create_master_text_21: "여러 개의 제품을 묶어 하나의 ‘셋업'으로 등록하려고 합니다.",
      _create_master_text_22: (index: number) => `제품명 ${index}`,
      create_master_text_24: "시중가",
      create_master_text_25: "(택가격)",
      create_master_text_25_jp: "(택가격:엔)",
      create_master_text_26: "셋업 제품 추가하기 +",
      create_master_text_27: "스타일을 선택해주세요.",
      create_master_text_28: "상위 카테고리",
      create_master_text_29: "카테고리를 선택해주세요.",
      create_master_text_30: "하위 카테고리",
      create_master_text_31: "부자재",
      create_master_text_32: "제품 파손/분실 유의사항",
      _create_master_text_33: () => <>대여 특성 상 일상 중에 착용하기 때문에 '인플루언서 귀책사유 및 물류 운영 과정 등' 모든 범위에서 파손 또는 분실이 발생할 수 있습니다. 이에 대해서 본사는 배상책임이 없음을 동의합니다.</>,
      create_master_text_34: "다른 색상 추가하기 +",
      create_master_text_35: "상세 이미지 업로드",
      _create_master_text_36: ({isVisibleSizeMessage}: {isVisibleSizeMessage?: boolean}) => (
        <>
          * 세로 길이 10,000px 이상의 이미지는 여러 장으로 나누어서 업로드 해주세요. (앱에서 튕김 현상이 발생할 수 있습니다.)
          {isVisibleSizeMessage && (
            <>
              <br />* 사이즈 정보를 반드시 업로드 해주세요.
            </>
          )}
          <br />* 5MB 이하의 파일을 업로드 해주세요.
        </>
      ),
      create_master_text_37: "벨트, 브로치 등의 부자재가 포함된 경우 작성해주세요.",
      create_master_text_38: "1개 이상의 상세이미지가 필요합니다. 먼저 이미지를 추가 후 삭제해주세요.",
      create_master_text_39: "사이즈를 입력해주세요.",
      create_master_text_40: "소매가",
      _create_master_text_41: () => (
        <>
          상/하의를 합쳐 하나의 '셋업'으로 등록하면, 지원자가 훨씬 많아집니다.
        </>
      ),
      _create_master_text_42: () => (
        <>
          상/하의를 합쳐 하나의 ‘셋업’으로 등록하면, 제품은 실제로 2개이지만 비용 청구는 1번만 되기 때문에 경제적으로 이득입니다.
        </>
      ),
      create_master_text_43: "지원하지 않는 이미지 파일 형식입니다.",
      create_master_text_44: "이미지의 세로 길이를 10,000px 이하로 분할해주세요.",
      create_master_text_45: `브랜드 태그`,
      create_master_text_46: `제품 브랜드 태그를 입력해주세요. (옵션)`,
      create_master_text_47: `꿀팁`,
      create_master_text_48: `기본 정보 입력`,
      _create_master_text_49: (index: number) => `색상 정보 ${index + 1 ? `${index + 1} ` : ``}입력`,
      create_master_text_50: <>
        * 정사각형 비율을 권장합니다.
        <br />
        * 앱에서 썸네일 이미지로 사용됩니다.
        <br />
        * 5MB 이하의 파일을 업로드 해주세요.
      </>,
      create_master_text_51: "상세 이미지",
      create_master_text_52: "색상명",
      create_master_text_53: "사이즈",
      create_master_text_54: "(예: 상의 M)",
      create_master_text_55: "대표 이미지 업로드",
      create_master_text_56: "수량",
      create_master_text_56_full: "이 사이즈의 수량",
      create_master_text_57: '* 브랜드명을 포함하지 말고 순수하게 제품명만 입력해 주세요.',
      index_search_option_1: "전체",
      index_search_option_2: "등록중",
      index_search_option_3: "등록완료",
      index_search_option_4: "입고중",
      index_search_option_5: "진행중",
      index_search_option_6: "반납요청",
      index_search_option_7: "반납요청접수",
      index_search_option_8: "반납중",
      index_search_option_9: "반납",
      index_text_1: "브랜드 정보를 불러올 수 없습니다.",
      index_text_2: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층 (010-9635-9152)",
      index_text_3: "복사완료",
      index_text_4: "복사가 완료되었습니다.",
      index_text_5: "복사실패",
      index_text_6: "복사가 제한되었습니다.",
      index_text_7: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층",
      index_text_8: "복사하기",
      index_text_9: "입고된 제품 수",
      index_text_10: "개",
      index_text_11: "등록은 완료했지만 검수가 안된 제품 수",
      index_text_12: `${getServiceName()} 물류에 입고를 완료하시면 1~2일 이내에 검수가 완료됩니다.\n입력된 제품정보와 실제 입고된 제품이 상이한 경우 검수가 완료되지 않습니다.`,
      index_text_13: "회수를 요청한 제품 수",
      index_text_14: `${getServiceName()}은 회수 요청시 가장 빠른 날짜로 반납합니다.\n"퀵으로 오늘 보내주세요”와 같은 요청은 물류상황에 따라 어려울 수 있습니다.`,
      index_text_15: "현재 대여 중인 일반 모델 수",
      index_text_16: "명",
      index_text_17: "현재 대여 중인 엠베서더 모델 수",
      index_text_18: "인기가 많아 추가로 입고하면 좋은 제품을 확인해 보세요!",
      index_text_19: "제품정보 입력하기",
      index_text_20: "모두선택",
      index_text_21: "선택한 제품 등록 접수하기",
      index_text_22: "선택한 제품 반납 신청하기",
      index_text_23: "제품명/부자재",
      index_text_24: "총 대여횟수",
      index_text_25: "수정/삭제",
      index_text_26: `${getServiceName()}에게`,
      index_text_27: "복구중",
      index_text_28: `해당 제품을 삭제하시겠습니까?\r\n삭제된 제품은 복구할 수 없습니다.`,
      _index_text_29: (name: string) => `${name}을 성공적으로 삭제하였습니다.`,
      index_text_30: "제품 색상 / 사이즈 정보를 입력해주세요.",
      index_text_31: "파손/분실 관련 유의사항 보기",
      index_text_32: "결과물",
      index_text_33: "제품 파손/분실 유의사항",
      index_text_34: `대여 특성 상 일상 중에 착용하기 때문에 '인플루언서 귀책사유 및 물류 운영 과정 등' 모든 범위에서 파손 또는 분실이 발생할 수 있습니다. 이에 대해서 본사는 배상책임이 없음을 동의합니다.`,
      index_text_35: "변경되었습니다.",
      index_text_36: "릴스 포스팅은 엠베서더 모델만 가능합니다.",
      index_text_37: "가이드라인 설정하기",
      _index_text_38: (nextTargetName: string) => `${nextTargetName}로 변경 시 필수 동의항목`,
      _index_text_39: ({ beforeTargetName, nextTargetName }: any) => `${beforeTargetName}에 동의하여 옷을 대여해간 모델이 있는 경우, ${"\n"}해당 모델은 ${nextTargetName}에 동의하지 않았으므로 ${beforeTargetName}을(를) 업로드할 수 있음에 동의해 주셔야 합니다.`,
      index_text_40: "동의합니다",
      index_text_41: `대여현황`,
      _index_text_42: (qty:number) => `대여중(${qty})`,
      index_text_43: `게시물`,
      index_text_44: `제품명 검색`,
      _index_text_45: (productCount:number) => `‘제출하기’ 가능한 제품만 전부 선택하기 (${productCount})`,
      _index_text_46: (productCount:number) => `‘반납 요청하기’ 가능한 제품만 전부 선택하기 (${productCount})`,
      index_text_47: `제출하기 할 제품을${'\n'}선택하고 계신 것 아니었나요?`,
      index_text_48: `제출하기 할 제품과 반납 요청하기 할 제품은${'\n'}동시에 선택할 수 없습니다.`,
      index_text_49: `반납 요청하기 할 제품을${'\n'}선택하고 계신 것 아니었나요?`,
      index_text_50: `반납 요청하기 할 제품과 제출하기 할 제품은${'\n'}동시에 선택할 수 없습니다.`,
      index_text_51: `제출하기`,
      index_text_52: `반납 요청하기`,
      index_text_53: `입력한 제품정보 제출하기`,
      index_text_54: `제품 반납 요청하기`,
      index_text_55: `제출하기 완료`,
      index_text_56: `이제 오늘룩 물류센터로 제품을 보내주시면${'\n'}바로 검수 작업을 시작합니다.`,
      index_text_57: `반납 요청하기 완료`,
      index_text_58: `오늘룩이 반납요청을 확인할 때까지${'\n'}조금만 기다려 주세요.`,
      index_text_60: `다른 제품까지 한꺼번에${'\n'}제출하시겠어요?`,
      _index_text_61: (qty:number) => `제출하기 할 수 있는 제품이 ${qty}개 더 있습니다.`,
      index_text_62: `다른 제품까지 한꺼번에${'\n'}반납 요청하시겠어요?`,
      _index_text_63: (qty:number) => `반납 요청하기 할 수 있는 제품이 ${qty}개 더 있습니다.`,
      _index_text_64: (selectedQty:number, totalQty:number) => `선택한 제품 제출하기 (${selectedQty}/${totalQty})`,
      _index_text_65: (selectedQty:number, totalQty:number) => `선택한 제품 반납 요청하기 (${selectedQty}/${totalQty})`,
    },
    rental: {
      ambassador_index_text_3: "브랜드 정보를 불러올 수 없습니다.",
      ambassador_index_text_4: "현재 준비중인 기능입니다.",
      ambassador_index_text_5: "카드 연동을 완료해주세요.",
      ambassador_index_text_6: `일반 모델 이용은 유료입니다.${"\n"}카드 연동을 완료하면,${"\n"}엠베서더 모델 이용이 가능합니다.`,
      ambassador_index_text_7: "카드 연동하기",
      ambassador_index_text_8: "일반모델 대여 중단",
      ambassador_index_text_9: "일반모델 대여 시작",
      _ambassador_index_text_10: (count: number) => `현재 일반 모델이 ${count}개의 제품을 대여 중이예요.${"\n"}엠베서더 모델 대여는 이 대여 건까지 완료하도록 할게요.`,
      ambassador_index_text_11: "일반 모델을 대상으로한 대여 서비스를 활성화합니다.",
      ambassador_index_text_12: "이 결정은 모델의 활동에 영향을 미치는 매우 중요한 결정입니다. 신중하게 진행해 주세요.",
      ambassador_index_text_13: "엠베서더 모델 포스팅 가이드라인을 먼저 설정해 주세요.",
      ambassador_index_text_14: "엠버서더 모델 포스팅 가이드라인을 먼저 설정해 주시면 이용이 가능합니다.",
      ambassador_index_text_15: "설정하러 가기",
      ambassador_index_text_16: "카드 연동을 완료해주세요.",
      ambassador_index_text_17: `엠베서더 모델 이용은 유료입니다.${"\n"}카드 연동을 완료하면,${"\n"}엠베서더 모델 이용이 가능합니다.`,
      ambassador_index_text_18: "엠베서더 대여 중단",
      ambassador_index_text_19: "엠베서더 대여 시작",
      _ambassador_index_text_20: (count: number) => `현재 엠베서더 모델이 ${count}개의 제품을 대여 중이예요.${"\n"}엠베서더 모델 대여는 이 대여 건까지 완료하도록 할게요.`,
      ambassador_index_text_21: "엠베서더를 대상으로한 대여 서비스를 활성화합니다.",
      ambassador_index_text_22: "이 결정은 모델의 활동에 영향을 미치는 매우 중요한 결정입니다. 신중하게 진행해 주세요.",
      ambassador_index_text_23: "모델 설정",
      ambassador_index_text_24: "우리 제품을 대여할 수 있는 모델",
      ambassador_index_text_25: "일반 모델 (릴스 불가)",
      _ambassador_index_text_26: (unit: string) => `일반 모델이 포스팅을 만들 때마다 15,000${unit}이 부과됩니다. (VAT 별도) 가격은 저렴하지만 모델을 직접 선택할 수 없고, 포스팅 퀄리티가 엠베서더 모델에 비해 조금 떨어질 수 있습니다.`,
      ambassador_index_text_27: "엠베서더 모델 (릴스 가능)",
      _ambassador_index_text_28: (unit: string) => `엠베서더 모델이 포스팅을 만들 때마다 35,000${unit}이 부과되고 (VAT 별도), 이 중 20,000${unit}이 모델에게 지급됩니다. 모델을 직접 선택할 수 있는 기능이 제공되며, 가이드라인 설정이 가능합니다. 포스팅 퀄리티가 일반 모델보다 높을 것을 기대할 수 있습니다.`,
      ambassador_index_text_29: "브랜드의 80%가 이용 중",
      ambassador_index_text_30: "1명이 한달에 착용 가능한 최대 제품 수",
      ambassador_index_text_31: "엠베서더 모델 지원자 알림 받기",
      ambassador_index_text_32: "알림 받기",
      ambassador_index_text_33: "엠베서더 모델 가이드라인",
      ambassador_index_text_34: "설정하기",
      ambassador_index_text_35: "모델 리스트",
      ambassador_index_text_36: "엠베서더 모델",
      ambassador_index_text_37: "선정이 완료되었습니다.",
      ambassador_index_text_38: `'우리 제품을 대여할 수 있는 모델' 항목에서 '엠베서더 모델만' 혹은 '일반 모델 및 엠베서더 모델 모두'를 선택하시면 선정한 모델에게 대여가 가능해집니다.`,
      ambassador_index_text_39: "우리 제품을 증정 받아본 적 있는 모델만 보기",
      ambassador_index_text_40: "내가 찜한 모델만 보기",
      ambassador_index_text_41: "최신순",
      ambassador_index_text_42: "평점순",
      ambassador_index_text_43: "팔로워순",
      ambassador_index_text_44: "라이크순",
      ambassador_index_text_45: "찜순",
      ambassador_index_text_47: "검색 조건을 변경해주세요.",
      ambassador_index_text_48: "엠베서더 모델로 선정하기",
      ambassador_index_text_49: "선택한 모델을 엠베서더 모델로 선정합니다.",
      ambassador_index_text_50: "선택한 모델을 엠베서더 모델 탈락시킵니다.",
      ambassador_index_text_51: "일반 모델 포스팅 가이드라인에 먼저 동의해 주세요.",
      ambassador_index_text_52: "일반 모델 포스팅 가이드라인에 동의해주시면 이용이 가능합니다.",
      ambassador_index_text_53: "동의하러 가기",
      ambassador_index_text_54: "일반 모델 포스팅 가이드라인",
      ambassador_index_text_55: "가이드라인 보기",
      ambassador_index_text_56: () => <>릴스 생성을 원하시는 경우, 가이드라인을 설정한 후에 제품 별 릴스로 변경하면 됩니다.</>,
      ambassador_index_text_57: "포스팅 가이드라인 설정하기",
      ambassador_index_text_58: "릴스 가이드라인 설정하기",
      ambassador_index_text_59: "일반 모델 통해 포스팅 생성 시 주의사항",
      ambassador_index_text_60: "1. 다른 브랜드와 동시에 태그될 수 있습니다.",
      ambassador_index_text_61: "2. 다른 협찬에 함께 태그될 수 있습니다.",
      ambassador_index_text_62: "태그 가이드라인",
      ambassador_index_text_63: "사진 가이드라인",
      ambassador_index_text_64: "일반 모델 가이드라인 동의하기",
      ambassador_index_text_65: "일반 모델 가이드라인에 동의합니다.",
      ambassador_index_text_66: "동의하시면 일반 모델을 통한 포스팅 생성이 가능해 집니다.",
      ambassador_index_text_67: "동의합니다",
      _ambassador_index_text_68: (count: number) => `지원 한 모델 수 : ${count}`,
      ambassador_index_text_69: "문의 접수가 완료되었습니다.",
      ambassador_index_text_70: "엠베서더 서비스 이용 문의",
      ambassador_index_text_71: "요청이 진행중입니다.",
      ambassador_index_text_72: "선정이 완료되었습니다.",
      ambassador_index_text_73: `'우리 제품을 대여할 수 있는 모델' 항목에서\n'엠베서더 모델만' 혹은 '일반 모델 및 엠베서더 모델 모두'를 선택하시면\n선정한 모델에게 대여가 가능해집니다.`,
      ambassador_index_text_74: "탈락시킬 모델을 선택해주세요.",
      ambassador_index_text_75: "엠베서더 모델 탈락시키기",
      ambassador_index_text_76: "선택한 모델의 엠베서더 지원을 반려합니다.",
      ambassador_index_text_77: "엠베서더 모델 중단시키기",
      ambassador_index_text_78: "현재 대여중인 옷이 있는 모델이 있는 경우\n해당 대여 건까지 포스팅하면 금액이 청구 완료되고,\n이후부터 해당 모델은 이용이 불가능해집니다.",
      ambassador_index_text_79: "엠베서더 모델로 선정하기",
      ambassador_index_text_80: "선택한 모델을 엠베서더 모델로 선정합니다.",
      ambassador_index_text_81: "선정할 모델을 선택해주세요.",
      ambassador_index_text_82: "결제 상한선 올리는 것을 고려해 주세요!",
      ambassador_index_text_83: "엠베서더 수를 늘리는 것 보다 결제 상한선을 올리는 것이 컨텐츠 생산에 도움이 더 되는 상태입니다.",
      _ambassador_index_text_84: (currentAmbassadorCount, targetAmbassadorCount) => (`엠베서더 모델을 최소 ${targetAmbassadorCount}명 이상 선정해 주세요! (현재 ${currentAmbassadorCount}/${targetAmbassadorCount}명)`),
      ambassador_index_text_85: "엠베서더 모델이 매일 우리 제품을 빌려가는 것이 아니기 때문에, 반드시 생각하시는 숫자보다 더 많이 엠베서더 모델을 선정해 두셔야 합니다.",
      ambassador_index_text_86: "결제 상한선 변경하러 가기",
      ambassador_index_text_87: `감도 높은 ${getServiceName()} 추천 모델만 보기`,
      ambassador_index_text_88: "엠베서더 선정순",
      ambassador_index_text_89: "브랜드 재선택순",
      _ambassador_index_text_90: () => (
        <>
          제품대여에서 <br />
          엠베서더 모델로 활동 중인 브랜드 수입니다. <br />
          엠베서더 모델 활동을 많이 할수록 좋은 인플루언서입니다.
        </>
      ),
      _ambassador_index_text_91: () => (
        <>
          제품증정에서 <br />
          제품증정을 2번 이상 진행한 브랜드 수입니다. <br />
          재선택 횟수가 많을수록 만족도가 높은 모델입니다.
        </>
      ),
      ambassador_index_text_92: `미선정 모델`,
      ambassador_index_text_93: `카테고리 필터`,
      ambassador_index_text_94: `활성도순`,
      _ambassador_index_text_95: () => (
        <>
          최근 {getServiceName()} 앱 활동 내역이 있는 모델을 우선하여 보여줍니다.
        </>
      ),
      _ambassador_index_text_96: (count: number) => `앰베서더 모델 수 : ${count}`,
      _ambassador_index_text_97: (count: number) => `미선정 모델 수 : ${count}`,
      ambassador_index_text_98: `강력 추천!`,
      ambassador_index_text_99: `엠베서더를 계속 선정하면 AI가 학습을 통해 브랜드와 더 잘 맞는 인플루언서를 추천해 드립니다.`,
      ambassador_index_text_100: `일일이 선정하기 힘들다면, ${getServiceName()} 담당자에게 부탁해 보세요!`,
      ambassador_index_text_101: `(무료) 엠베서더 선정 대신 부탁하기`,
      ambassador_index_text_102: `의 감도 높은 인플루언서 목록을 이미 가지고 있습니다.`,
      
      ambassador_requirements_text_1: "해당 이미지를 삭제하시겠습니까?",
      ambassador_requirements_text_2: "성공적으로 해당 이미지를 삭제하였습니다.",
      ambassador_requirements_text_3: "엠베서더 모델 포스팅 가이드라인",
      ambassador_requirements_text_4: "이미지 가이드라인",
      ambassador_requirements_text_5: "1. 필수로 포스팅되어야하는 사진을 알려주세요",
      ambassador_requirements_text_6: "입력하신 메세지는 모델에게 표출됩니다.",
      ambassador_requirements_text_7: "매우 구체적이고 직관적으로 표현해주세요.",
      ambassador_requirements_text_8: `무신사 스냅에서 사용 예정이고, ${"\n\r"} 머리 발끝 잘리지 않도록 강조`,
      ambassador_requirements_text_9: "금지사항",
      ambassador_requirements_text_10: "2. 금지사항이 필요한 경우 체크해 주세요.",
      ambassador_requirements_text_11: "3. 브랜드에서 추가 할 이미지 가이드가 있다면 넣어주세요. (선택)",
      ambassador_requirements_text_12: "입력하신 이미지는 모델들에게 표출되고, 동의를 받습니다.",
      ambassador_requirements_text_13: "문구 가이드라인",
      ambassador_requirements_text_14: "4. 포스팅에 꼭 들어가야할 필수 문구가 있다면 알려주세요",
      ambassador_requirements_text_15: "입력하신 메세지는 모델에게 표출됩니다.",
      ambassador_requirements_text_16: "(예) 자사몰에서 신상 10% 할인중",
      ambassador_requirements_text_17: "태그 가이드라인",
      ambassador_requirements_text_18: "5. 브랜드의 인스타그램 @공식계정을 알려주세요.",
      ambassador_requirements_text_19: "타브랜드 태그",
      ambassador_requirements_text_20: "6. 포스팅 사진에 타 브랜드 태그가 들어가도 되나요?",
      ambassador_requirements_text_21: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "7. SNS에 릴스 업로드시, 함께 삽입될 #태그를 알려주세요.";
        default:
        return "7. SNS 포스팅 시, 함께 삽입될 #태그를 알려주세요.";
        }
      },
      ambassador_requirements_text_22: "'#' 제외하고 글자만 입력해주세요.",
      ambassador_requirements_text_23: "추가 #태그 설정",
      ambassador_requirements_text_24: `# 제외하고 글자만 입력`,
      ambassador_requirements_text_25: "해시태그 위치",
      ambassador_requirements_text_26: "8. 브랜드 해시태그가 들어갈 위치를 선택해 주세요.",
      ambassador_requirements_text_27: "협찬 및 광고",
      ambassador_requirements_text_28: "9. #광고 #협찬 태그",
      ambassador_requirements_text_29: "입력 내용을 확인해주세요.",
      ambassador_requirements_text_30: "릴스 가이드라인을 입력해주세요.",
      ambassador_requirements_text_31: "사진 가이드라인을 제외하거나 1개 이상 설정해주세요",
      ambassador_requirements_text_32: "브랜드 태그 입력 에러가 발생했습니다. 다시 접속해주세요",
      ambassador_requirements_text_33: "브랜드 태그를 입력해주세요",
      ambassador_requirements_text_34: "해시태그 입력 에러가 발생했습니다. 다시 접속해주세요",
      ambassador_requirements_text_35: "해시태그를 입력해주세요",
      ambassador_requirements_text_36: "금지사항을 선택해주세요.",
      ambassador_requirements_text_37: "타브랜드 태그 허용 여부를 선택해주세요.",
      ambassador_requirements_text_38: "해시태그 위치를 선택해주세요.",
      ambassador_requirements_text_39: "#광고 #협찬 태그 표기 여부를 선택해주세요.",
      ambassador_requirements_text_40: "모두 입력되었습니다.",
      ambassador_requirements_text_41: "수정되었습니다.",
      ambassador_requirements_text_42: "수정 중 에러가 발생했습니다. 새로고침 후 다시 시도해주세요.",
      ambassador_requirements_text_43: "해당 이미지를 삭제하시겠습니까?",
      ambassador_requirements_text_44: "이미지를 삭제하였습니다.",
      ambassador_requirements_text_45: "성공적으로 해당 이미지를 삭제하였습니다.",
      ambassador_requirements_text_46: "반드시 하나의 옵션을 선택해야 합니다.",
      ambassador_requirements_text_47: "엠베서더 모델 포스팅 가이드라인",
      ambassador_requirements_text_48: "이미지 가이드라인",
      ambassador_requirements_text_49: "1. 필수로 포스팅되어야하는 사진을 알려주세요",
      ambassador_requirements_text_50: "컨텐츠 생산 난이도가 높을수록 지원자 수가 줄어들 수 있습니다.",
      ambassador_requirements_text_56: "2. 금지사항이 필요한 경우 체크해 주세요.",
      ambassador_requirements_text_57: "3. 브랜드에서 추가 할 이미지 가이드가 있다면 넣어주세요. (선택)",
      ambassador_requirements_text_58: "입력하신 이미지는 모델들에게 표출되고, 동의를 받습니다.",
      ambassador_requirements_text_59: "문구 가이드라인",
      ambassador_requirements_text_60: "4. 포스팅에 꼭 들어가야할 필수 문구가 있다면 알려주세요",
      ambassador_requirements_text_61: "입력하신 메세지는 모델에게 표출됩니다.",
      ambassador_requirements_text_62: "(예) 자사몰에서 신상 10% 할인중",
      ambassador_requirements_text_63: "태그 가이드라인",
      ambassador_requirements_text_64: "5. 브랜드의 인스타그램 @공식계정을 알려주세요.",
      ambassador_requirements_text_65: "6. 포스팅 사진에 타 브랜드 태그가 들어가도 되나요?",
      ambassador_requirements_text_66: [
        `* 포스팅 시 @${getServiceNameEn()}, #${getServiceName()} 태그는 기본으로 제거됩니다`,
        "* 포스팅/릴스 가이드라인 모두 적용됩니다"
      ].join('\n'),
      ambassador_requirements_text_67: (category_id) => {
        switch(category_id){
        case CATEGORY_ID.BEAUTY:
        return "7. SNS에 릴스 업로드시, 함께 삽입될 #태그를 알려주세요.";
        default:
        return "7. SNS 포스팅 시, 함께 삽입될 #태그를 알려주세요.";
        }
      },
      ambassador_requirements_text_68: "'#' 제외하고 글자만 입력해주세요.",
      ambassador_requirements_text_69: "추가 #태그 설정",
      ambassador_requirements_text_70: "# 제외하고 글자만 입력",
      ambassador_requirements_text_71: "8. 브랜드 해시태그가 들어갈 위치를 선택해 주세요.",
      ambassador_requirements_text_72: "9. #광고 #협찬 태그",
      ambassador_requirements_text_73: "제출없이 Params 로그만 찍기",
      ambassador_requirements_text_74: "엠베서더 모델 릴스 가이드라인",
      ambassador_requirements_text_75: "릴스 가이드라인",
      ambassador_requirements_text_76: "1. 영상 가이드라인을 알려주세요.",
      ambassador_requirements_text_77: "매우 구체적이고 직관적으로 표현해주세요.",
      ambassador_requirements_text_78: "릴스 외 추가 사진 받기",
      ambassador_requirements_text_79: "10. 릴스 외 사진도 필요하신가요?",
      ambassador_requirements_text_80: "필요 없습니다.",
      ambassador_requirements_text_81: "추가 사진이 필요합니다.\n(추가 사진을 요청할수록 난이도가 높아져 지원율에 영향을 미칠 수 있습니다. 최대 3장의 사진을 요청할 수 있습니다.)",
      ambassador_requirements_text_82: "가이드라인 수정 시 필수 동의항목",
      ambassador_requirements_text_83: "이전 가이드라인에 동의하여 옷을 대여해간 모델이 있는 경우, 해당 모델은 바뀐 가이드라인에 동의하지 않았으므로 바뀐 가이드라인과 상관 없이 포스팅을 할 수 있음에 동의해 주셔야 합니다.",
      ambassador_requirements_text_84: "동의합니다",
      ambassador_requirements_text_85: "수정되었습니다",
      ambassador_requirements_text_86: "수정 중 에러가 발생했습니다. 새로고침 후 다시 시도해주세요.",
      ambassador_requirements_text_87: "사진 가이드라인을 1개 이상 설정해주세요",
      ambassador_requirements_text_88: "추천",
      ambassador_requirements_text_89: [
        `다른 브랜드와 같이 착용하면`,
        `좋은 인플루언서가 착용 할 확율이 높아집니다.`,
        `브랜드는 타 브랜드와 함께 노출 빈도가 높아집니다.`,
      ].join('\n'),
      ambassador_requirements_text_90: `*카페 실내 촬영도 금지됩니다`,
      _ambassador_requirements_text_91: (current:number, maximum:number)=>(
        `(${current}/${maximum} ${maximum}자 이내)`
      ),
      ambassador_requirements_text_92: "참고할 릴스 예시 URL",
      ambassador_requirements_text_93: "*릴스 생산을 위한 참고 목적의 영상입니다.",
      ambassador_preview_text_1: "앰베서더 서비스가 비활성화 상태입니다.",
      ambassador_preview_text_2: "앰베서더가 대여 대상이 아닙니다.",
      ambassador_preview_text_3: "모델 리스트",
      _ambassador_preview_text_4: ()=>(
        <>PC로 브랜드 관리자페이지에 접속해서
        <br />
        엠베서더 모델을 선정해 주세요!</>
      ),
      ambassador_preview_text_5: "엠베서더 모델이 뭔가요?",
      _ambassador_preview_text_6: ()=>(
        <>
          {`이제 원하는 모델을 직접`}
          <br />
          {`선택해 제품을 빌려주세요`}
        </>
      ),
      ambassador_preview_text_7: "특정 모델을 엠베서더 모델로 선정하면, 그 모델만 우리 제품을 빌려갈 수 있게 할 수 있습니다. 쉽게 말해, 브랜드가 원하는 모델만 직접 선택해서 제품을 빌려갈 수 있게 할 수 있다는 의미입니다.", 
      ambassador_preview_text_8: "꼼꼼한 가이드라인 설정이 가능해요", 
      ambassador_preview_text_9: "엠베서더 모델에게 제품을 대여해줄 때 포즈, #태그 등에 대해 꼼꼼하게 가이드라인을 설정할 수 있어 퀄리티 높은 포스팅을 생산할 수 있어요.", 
      _ambassador_preview_text_10: (unit: string) => `월 10만${unit}부터 이용해보세요`, 
      _ambassador_preview_text_11: (unit: string) => `엠베서더 모델이 포스팅을 만들 때마다 35,000${unit}이 부과되고, 이 중 20,000${unit}이 모델에게 지급됩니다. 따라서 포스팅 퀄리티가 일반 모델보다 높을 것을 기대할 수 있습니다. 월 한도는 10만${unit}부터 설정 가능합니다.`, 
      _ambassador_preview_text_12: (count: number) => `지원 한 모델 수 : ${count}`,
      ambassador_preview_text_13: "지원자가 없습니다.",
      ambassador_preview_text_14: "배경사진을 등록하지 않은 사용자 입니다.",
      ambassador_preview_text_15: "찜했음",
      ambassador_preview_text_16: "인플루언서 찜하기",
      index_text_1: "신세계인터내셔날",
      index_text_2: "브랜드 정보를 불러올 수 없습니다.",
      index_text_3: "1. 제품을 등록하셨나요?",
      index_text_4: "제품등록 바로가기",
      index_text_5: "2. 제품을 보내셨나요?",
      index_text_6: "네, 발송을 완료했습니다.",
      index_text_7: `(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층${"\n"}(010-9635-9152)`,
      index_text_8: "3. 카드 등록을 완료하셨나요?",
      index_text_9: "카드등록 바로가기",
      index_text_10: "일반 모델",
      index_text_11: "엠베서더 모델",
      index_text_12: "선택 전",
      index_text_13: "일반 모델만",
      index_text_14: "엠베서더 모델만",
      index_text_15: "일반 모델 및 엠베서더 모델 모두",
      index_text_16: "제품 대여",
      index_text_17: "1. 제품",
      index_text_18: "입고된 제품 수",
      index_text_19: "등록은 완료했지만 검수가 안된 제품 수",
      index_text_20: "회수를 요청한 제품 수",
      index_text_21: "2. 결제",
      index_text_22: "월 결제 상한선",
      index_text_23: "월 결제 상한선 이상은 결제가 이루어지지 않습니다.",
      index_text_24: "VAT 별도",
      _index_text_25: (month: any) => `${month}월 청구 예정금액`,
      _index_text_26: (currentMonth: any, nextMonth: any) => `${currentMonth}월에 이용한 금액은 ${nextMonth}월 15일에 결제될 예정입니다.`,
      index_text_27: "VAT 별도",
      index_text_28: "3. 모델 설정",
      index_text_29: "우리 옷을 대여할 수 있는 모델",
      index_text_30: "선정 대기 중인 엠베서더 모델 지원자 수",
      index_text_31: "모델 1명이 1달 동안 최대 착용 가능한 제품 수",
      index_text_32: "4. 포스팅",
      _index_text_33: (month: any) => `${month}월 완료된 포스팅 수`,
      _index_text_34: (amount: any) => `엠베서더 포스팅 ${amount}개`,
      _index_text_35: (amount: any) => `일반 포스팅 ${amount}개`,
      _index_text_36: (month: any) => `${month}월 생성 중인 포스팅 수`,
      index_text_37: "복사완료",
      index_text_38: "복사가 완료되었습니다.",
      index_text_39: "복사실패",
      index_text_40: "복사가 제한되었습니다.",
      index_text_41: "복사하기",
      _index_text_42: () => (
        <>
          아래 모든 단계를 완료했을 때 <br />
          포스팅 생성이 시작됩니다.
        </>
      ),
      intro_text_1: "모델에게 제품 대여해주고",
      intro_text_2: "컨텐츠 만들어보세요",
      intro_text_3: "퀄리티 높은 컨텐츠를 만들어 드립니다.",
      intro_text_4: "소개서 다운받기",
      intro_text_5: `제품증정(시딩)을 하기엔 `,
      intro_text_6: `단가가 너무 높으신가요 ?`,
      intro_text_7: `제품 하나로 여러 인플루언서에게 대여해 `,
      intro_text_8: `컨텐츠를 얻을 수 있습니다.`,
      intro_text_9: "Check Point 1",
      intro_text_10: "Check Point 2",
      intro_text_11: `의상만 맡기면 ${getServiceName()}이 알아서`,
      intro_text_12: `의상만 제공해주시면 세탁/운영/컨텐츠제작 `,
      intro_text_13: `전부 ${getServiceName()}이 해드립니다.`,
      intro_text_14: "Check Point 3",
      intro_text_15: "자체 세탁 시설로 깨끗하게 의상 관리",
      intro_text_16: "매 대여 시 마다 세탁을 진행합니다.",
      intro_text_17: "제작된 컨텐츠 무제한 2차 활용",
      intro_text_18: `무신사 스냅, 광고, 자사몰, 인스타그램 등 `,
      intro_text_19: `원하는 곳에 자유롭게 사용`,
      intro_text_20: "Check Point 5",
      intro_text_21: "2천명의 인플루언서와 함께합니다",
      intro_text_22: "페미닌/캐주얼/섹시글램/골프 등 다양한 스타일의 모델",
      intro_text_23: "Check Point 6",
      intro_text_24: `엠베서더 모델을 선정해서 `,
      intro_text_25: `내가 원하는 모델에게만 `,
      intro_text_26: `옷을 빌려주세요`,
      intro_text_27: `4천명의 모델 중 `,
      intro_text_28: `우리 브랜드 이미지에 맞는 모델 선택 가능`,
      intro_text_29: "Check Point 4",
      intro_text_30: "Check Point 7",
      intro_text_31: "정교한 가이드라인 설정 가능",
      intro_text_32: "포스팅의 만족도 상승",
      intro_text_33: "Check Point 8",
      _intro_text_34: (unit: string) => `월 10만${unit}부터 이용 가능한 요금제`,
      intro_text_35: "부담 없이 합리적으로 이용 가능한 가격",
      intro_text_36: "400+개 브랜드가 이용 중",
      intro_text_37: `높은 만족도로 `,
      intro_text_38: `매우 낮은 이탈율을 보이고 있습니다.`,
      intro_text_39: "소개서 다운받기",
      intro_text_41: () => (
        <>
          {`하나의 제품으로 `}
          <br />
          {`수많은 컨텐츠를 생산해 보세요`}
        </>
      ),
      intro_text_42: () => (
        <>
          {`아래와 같은 경우 `}
          <br className="flex md:hidden" />
          {`제품 대여를 통한 컨텐츠 생산이 답입니다.`}
        </>
      ),
      intro_text_43: () => (
        <>
          {`제품만 맡기면 `}
          <br />
          {`${getServiceName()}이 알아서 해드려요`}
        </>
      ),
      intro_text_44: () => (
        <>
          {`${getServiceName()}은 연예인 협찬 대행사의 `}
          <br className="flex md:hidden" />
          {`온라인 인플루언서 버전입니다.`}
        </>
      ),
      intro_text_45: () => (
        <>
          {`4천명의 인플루언서와 `}
          <br />
          {`함께합니다`}
        </>
      ),
      intro_text_46: () => (
        <>
          {`페미닌/캐주얼/섹시글램/골프 등 `}
          <br className="flex md:hidden" />
          {`스타일이 다양합니다.`}
        </>
      ),
      intro_text_47: () => (
        <>
          {`엠베서더 모델을 선정해서 `}
          <br />
          {`내가 원하는 모델에게만 `}
          <br className="flex md:hidden" />
          {`제품을 빌려주세요`}
        </>
      ),
      intro_text_48: () => (
        <>
          {`4천명의 모델 중 `}
          <br className="flex md:hidden" />
          {`우리 브랜드 이미지에 맞는 모델을 선택 가능합니다.`}
        </>
      ),
      intro_text_49: () => (
        <>
          {`일반 모델과 `}
          <br />
          {`엠베서더 모델 비교`}
        </>
      ),
      intro_text_50: `어떤 차이가 있는지 한눈에 확인하세요.`,
      intro_text_51: () => (
        <>
          {`엠베서더 포스팅은 `}
          <br />
          {`정교한 가이드라인 설정 가능`}
        </>
      ),
      intro_text_52: `브랜드가 직접 가이드라인을 설정할 수 있습니다.`,
      intro_text_53: () => (
        <>
          {`컨텐츠 2차 활용은`}
          <br />
          {`무제한 무료`}
        </>
      ),
      intro_text_54: () => (
        <>
          {`원하는 용도로 기간의 제한 없이 `}
          <br className="flex md:hidden" />
          {`무료로 이용할 수 있습니다.`}
        </>
      ),
      intro_text_55: () => (
        <>
          {`400+개`}
          <br />
          {`브랜드가 이용 중`}
        </>
      ),
      intro_text_56: () => `높은 만족도로 매우 낮은 이탈율을 보이고 있습니다.`,

      _payments_budget_option: (unit: string) => [
        { name: `70만${unit}`, value: 700000 },
        {
          name: `105만${unit}`,
          value: 1050000,
          tooltip: `한 달에 30개 포스팅을 기대할 수 있습니다.${"\n"}(3.5만${unit} * 30개 = 105만${unit})`
        },
        { name: `200만${unit}`, value: 2000000 },
        { name: `500만${unit}`, value: 5000000 }
      ],

      payments_text_1: "결제 예정금액보다 낮은 상한선을 설정했습니다.",
      _payments_text_2: (money: any, amount: any, unit: string) => `이번 달 대여는 ${money}${unit}에서 중단합니다.\n다음 달 부터는 ${amount}${unit}까지만 결제 될 예정입니다.`,
      payments_text_3: "카드 등록하기",
      payments_text_4: "월 결제 상한선 (VAT 별도)",
      _payments_text_5: (unit: string) => `월 결제 상한선으로 정한 금액은 VAT를 나중에 돌려받을 수 있으므로 VAT 별도 금액으로 결제됩니다.${"\n"}(예: 월 결제 상한선 100만${unit} 설정 시, 실제 결제금액은 VAT 10%가 추가된 110만${unit})`,
      payments_text_6: "월 결제 상한선 설정 완료",
      payments_text_7: `월 결제 상한선을 무제한으로 설정합니다.${"\n"}(VAT 별도)`,
      payments_text_8: "금액 직접 입력",
      _payments_text_9: (unit: string) => `만${unit}`,
      _payments_text_10: (unit: string) => `${unit}`,
      _payments_text_11: (budget: any, suffix: any) => `월 결제 상한선을 ${budget || 0}${suffix}으로 설정합니다.${"\n"}(VAT 별도)`,
      payments_text_12: "결제 예정금액",
      payments_text_13: `1. 포스팅 검수까지 완료됐을 때 청구합니다.\n2. 지금 대여 중인 제품이 포스팅되지 않을 경우 청구하지 않습니다.`,
      payments_text_14: "등록된 카드가 없습니다.",
      payments_text_15: "카드관리 메뉴로 이동하기",
      payments_text_16: "서비스 이용 중단하기",
      _payments_text_17: (month: any, money: any, unit: any) => `${month}월 결제 예정금액 ${money}${unit}을 즉시 결제합니다. (VAT 별도)\n진행 중인 서비스가 중단되고 제품은 즉시 반납됩니다.`,
      _payments_text_18: (month: any) => `${month}월 결제 예정금액이 없습니다.\n진행 중인 서비스가 중단되고 제품은 즉시 반납됩니다.`,
      payments_text_19: `서비스 이용 중단할게요`,
      payments_text_20: "계속 이용할게요",
      payments_text_21: "결제 됩니다",
      payments_text_22: "결제되었습니다.",
      payments_text_23: "결제 예정입니다.",
      _payments_text_24: (month: any) => `${month}월에 이용한 금액은`,
      _payments_text_25: (month: any, paidStatusText: any) => `${month}월 15일에 ${paidStatusText}`,
      payments_text_26: "최종 결제 예정금액",
      payments_text_27: `제품이 대여 중인데 포스팅이 미완료되면${"\n"}최종 결제 예정금액보다 적게 결제될 수 있습니다.`,
      payments_text_28: "VAT 별도",
      payments_text_29: "일반모델",
      payments_text_30: "완료된 포스팅",
      _payments_text_31: (count: any) => `포스팅 ${count}개`,
      payments_text_32: "생성 중인 포스팅",
      payments_text_33: "엠베서더 모델",
      _payments_text_34: (unit: string) => `한 달에 30개 포스팅을 기대할 수 있습니다.${"\n"}(3.5만${unit} * 30개 = 105만${unit})`,
      payments_text_35: "브랜드의 80%가 이용 중"
    },
    reports: {
      index_text_1: "인기 많은 순",
      index_text_2: "인기 적은 순",
      index_text_3: "최근 2주",
      index_text_4: "월별",
      index_text_5: "제품 목록을 불러오는데 실패하였습니다.",
      index_text_6: "2주 리포트",
      index_text_7: "제품대여",
      _index_text_8: (totalClothes: any, diffFromLastApprovedDate: any) => (
        <>
          <div className="flex flex-row">
            <span className="text-[20px] heading-snug tracking-tighter text-white">{`현재 총 `}</span>
            <span className="text-[20px] heading-snug tracking-tighter text-[#000000]">{`${totalClothes ?? "0"}벌이 `}</span>
            <span className="text-[20px] heading-snug tracking-tighter text-white">{` 입고되어 있으며,`}</span>
          </div>
          <div className="flex flex-row">
            <span className="text-[20px] heading-snug tracking-tighter text-white">{`마지막 입고일로부터 `}</span>
            <span className="text-[20px] heading-snug tracking-tighter text-[#EF5DA8]">{`${diffFromLastApprovedDate ? diffFromLastApprovedDate : "0"}일 `}</span>
            <span className="text-[20px] heading-snug tracking-tighter text-white">{`지났습니다.`}</span>
          </div>
        </>
      ),
      _index_text_9: (brandName: any) => `${brandName}의 마지막 입고 날짜 : `,
      index_text_10: "제품증정",
      index_text_11: "바로가기",
      _index_text_12: (totalCampaigns: any) => (
        <>
          현재 <b className="text-[#5D5FE7]">210개 브랜드</b>가 제품증정 중이며,
          <br />
          우리는 지금까지 <b className="text-[#DD66A6]">{`${totalCampaigns}번`}</b> 진행했습니다.
        </>
      ),
      index_text_13: "지난 2주 인기 순위",
      index_text_14: "인기 의상은 미리 추가 입고를 고려해 주세요! 😊",
      index_text_15: "전체보기",
      index_text_16: "의상 썸네일",
      index_text_17: "클릭 수",
      index_text_18: "입고되어있음",
      index_text_19: "차트 정보를 불러오는데 실패하였습니다.",
      _index_text_20: (count: any) => `포스팅 : ${count} 건`,

      index_text_21: "포스팅 현황 그래프",
      _index_text_22: (count: any) => `누적 갯수 : ${count}개`,
      _index_text_23: (month: any, day: any) => `${month}월${day}일`,
      index_text_24: "지난 2주 포스팅",
      index_text_25: "전체 포스팅 보기",
      index_text_26: "화이트라벨 기능 업데이트!"
    },
    settings: {
      alarm_text_1: "브랜드 정보를 불러올 수 없습니다.",
      alarm_text_2: "알림 설정",
      alarm_text_3: "뉴스레터 구독 : 2주에 1번씩 뉴스레터를 보내드려요.",
      alarm_text_4: "인스타링크 : 포스팅 링크를 실시간으로 보내드려요.",
      alarm_text_5: "엠베서더 지원 : 엠베서더 지원시 알림을 보내드려요.",
      alarm_text_6: "대여 예산 경고 : 대여 예산이 부족한 경우 알림을 보내드려요.",
      alarm_text_7: "담당자 이메일",
      alarm_text_8: "DEPRECATED_릴스 파일을 받을 이메일",
      alarm_text_9: "담당자 정보",
      alarm_text_10: "보고서 요약본과 포스팅을 정기적으로 보내드립니다.",
      alarm_text_11: "브랜드 정보 수정에 실패하였습니다.",
      alarm_text_12: "사장님 정보",
      alarm_text_13: "사장님",
      alarm_text_14: "직책을 입력해주세요",
      alarm_text_15: "연락처를 확인해주세요",
      brand_text_1: "@태그를 설정을 진행해주세요.",
      brand_text_2: "브랜드 정보 설정",
      brand_text_3: "앱에서 보여질 로고 이미지 (필수)",
      brand_text_4: "@태그 설정",
      brand_text_5: (category_id) => {
        switch(category_id){
          case CATEGORY_ID.BEAUTY:
              return "인스타그램에 릴스 업로드 시 삽입될 인스타그램 공식 계정을 적어주세요.";
            default:
              return "인스타그램 공식 계정을 적어주세요 .";
        }
      },
      brand_text_6: "@ 제외하고 글자만 입력",
      brand_text_7: "#태그 설정",
      _brand_text_8: () => (
        <>
          인스타그램 포스팅 시 입력될 #태그를 2개 적어주세요.
          <br />
          제품증정 캠페인 생성 시 더 추가할 수 있습니다.
        </>
      ),
      brand_text_9: "# 제외하고 글자만 입력",
      brand_text_10: "이대로 진행하기",
      brand_text_11: "브랜드 정보 수정에 실패하였습니다.",
      brand_text_12: "로고 이미지를 등록해주세요.",
      guide_menu_1: "기본 가이드라인",
      guide_menu_2: "브랜드에서 만든 가이드라인",
      guide_text_1: "모델에게 보여지는 포스팅 가이드라인입니다.",
      guide_text_2: "해당 가이드를 삭제하시겠습니까?",
      guide_text_3: "성공적으로 해당 이미지를 삭제하였습니다.",
      password_text_1: "브랜드 정보를 불러올 수 없습니다.",
      password_text_2: "비밀번호 변경",
      password_text_3: "기존 비밀번호를 입력해 주세요.",
      password_text_4: "변경할 비밀번호를 입력해 주세요.",
      password_text_5: "변경할 비밀번호를 한 번 더 입력해 주세요.",
      password_text_6: "변경할 비밀번호 재확인 란을 입력해 주세요."
    },
    sns: {
      uploader_text_1: "대표 이미지",
      uploader_text_3: "상세페이지 URL",
      uploader_text_4: "착용 색상",
      uploader_text_5: "착용 사이즈",
      uploader_text_6: "제품 추가하기 +",
      uploader_text_7: "대표 이미지를 설정해주세요",
      uploader_text_8: "제품명을 입력해주세요",
      uploader_text_9: "상세페이지 URL을 입력해주세요",
      uploader_text_10: "착용 색상을 입력해주세요",
      uploader_text_11: "착용 사이즈를 입력해주세요",
      uploader_text_12: "제품 추가 중입니다.",
      uploader_text_13: "제품을 추가할 수 없습니다.",
      celeb_detail_text_1: "브랜드 정보를 불러올 수 없습니다.",
      celeb_detail_text_2: "연예인 리뷰 정보를 불러올 수 없습니다.",
      celeb_detail_text_3: "수정 중입니다.",
      celeb_detail_text_4: "연예인 리뷰 정보를 수정할 수 없습니다.",
      celeb_detail_text_7: "컨텐츠 수정하기",
      celeb_detail_text_8: "제품 정보",
      celeb_order_text_1: "연예인 리뷰",
      celeb_upload_text_1: "직접 올리기",
      celeb_upload_text_2: "썸네일 대표 이미지",
      celeb_upload_text_3: "상세 이미지",
      celeb_upload_text_4: "제품 정보",
      celeb_upload_text_5: "과거 제품 정보 불러오기",
      celeb_upload_text_6: "포스팅 등록하기",
      celeb_upload_text_7: "제목을 입력해주세요",
      celeb_upload_text_8: "제품을 하나 이상 선택해주세요",
      celeb_upload_text_9: "썸네일 대표 이미지를 설정해주세요",
      celeb_upload_text_10: "상세 이미지를 하나 이상 설정해주세요",
      celeb_upload_text_11: "업로드 중입니다.",
      celeb_upload_text_12: "연예인 리뷰 정보를 생성/수정할 수 없습니다.",
      celeb_upload_text_13: "등록 완료했습니다.",
      celeb_upload_text_14: "포스팅 등록에 실패했습니다.",
      index_text_1: "브랜드 정보를 불러올 수 없습니다.",
      index_text_2: "불러오는 중 입니다",
      _index_text_3: (name: string) => `${name}가 없습니다`,
      _index_text_4: (name: string) => `${name} 정보를 불러올 수 없습니다.`,
      index_text_5: "수정 중입니다",
      _index_text_6: (name: string) => `${name} 정보를 수정할 수 없습니다.`,
      index_text_7: "유튜브 리뷰",
      index_text_8: "자사몰 연동 및 관리",
      index_text_9: "컨텐츠 순서 변경하기",
      index_text_10: "컨텐츠 직접 올리기",
      _index_text_11: (name: string) => `${name} 더 보기`,
      product_text_1: "제품명 검색",
      _resource_text_1: (name: string) => `${name} 순서 변경하기`,
      _resource_text_2: (name: string) => (
        <>
          클릭해서 끌어다 놓으면 순서를 변경하실 수 있습니다.
          <br />
          공개된 {name}만 보여집니다.
        </>
      ),
      _resource_text_3: (name: string) => `공개된 ${name} 정보가 없습니다.`,
      resource_text_4: "변경 중입니다",
      _resource_text_5: (name: string) => `${name} 정보를 수정할 수 없습니다.`,
      resource_text_6: "순서변경 완료",
      right_side_text_1: "URL 변경하기",
      right_side_text_2: "제품의 상세페이지 URL을 입력해 주세요.",
      video_detail_text_1: "비디오 리뷰 정보를 불러올 수 없습니다.",
      video_detail_text_2: "비디오 리뷰 정보를 수정할 수 없습니다.",
      video_upload_text_1: "비디오 정보를 불러올 수 없습니다.",
      video_upload_text_2: "비디오 리뷰",
      video_upload_text_3: "URL을 입력해주세요",
      video_upload_text_4: "비디오 리뷰 정보를 생성/수정할 수 없습니다.",
      youtube_detail_text_1: "유튜브 리뷰 정보를 불러올 수 없습니다.",
      youtube_detail_text_2: "유튜브 리뷰 정보를 수정할 수 없습니다.",
      youtube_upload_text_1: "유튜브 정보를 불러올 수 없습니다.",
      youtube_upload_text_2: "유튜브 리뷰 정보를 생성/수정할 수 없습니다.",
      create_text_1: "포스팅 사진 삭제하기",
      create_text_2: "삭제된 이미지는 복구될 수 없습니다. 해당 이미지를 삭제하시겠습니까?",
      create_text_3: "프로필 사진 삭제하기",
      create_text_4: "프로필 사진 (선택)",
      create_text_5: "제품 대표 이미지 삭제하기",
      create_text_6: "대표 이미지",
      create_text_7: "제품 삭제하기",
      create_text_8: "포스팅 수정하기",
      create_text_9: "포스팅 등록하기",
      create_text_10: "포스팅 사진",
      create_text_11: "순서 변경",
      create_text_12: "모델 정보",
      create_text_13: "상의 사이즈",
      create_text_14: "하의 사이즈",
      create_text_15: "신발 사이즈 (선택)",
      create_text_16: "브라 사이즈 (선택)",
      create_text_17: "팬티 사이즈 (선택)",
      create_text_18: "포스팅 사진을 등록해주세요.",
      create_text_19: "모델의 이름를 입력해주세요.",
      create_text_20: "모델의 나이를 입력해주세요.",
      create_text_21: "모델의 키를 입력해주세요.",
      create_text_22: "모델의 상의 사이즈를 입력해주세요.",
      create_text_23: "모델의 하의 사이즈를 입력해주세요.",
      create_text_24: "1개 이상의 제품을 추가해주세요",
      create_text_25: "일부 제품의 이미지가 누락되었습니다.",
      create_text_26: "일부 제품의 품명이 누락되었습니다.",
      create_text_27: "일부 제품의 URL이 누락되었습니다.",
      create_text_28: "일부 제품의 색상이 누락되었습니다.",
      create_text_29: "일부 제품의 사이즈가 누락되었습니다.",
      create_text_30: "자사몰에 노출되는 정보입니다. 이후 수정은 가능하지만 반영에 시간이 걸리기 때문에 각 정보들을 정확하게 입력해주세요. (특히 URL은 자사몰에서 해당 제품을 눌렀을 때 이동되는 링크이기에 작동을 확인해주세요.)",
      index_text_21: "자사몰 연동하기",
      _index_text_22: () => (
        <>
          먼저 결제를 진행하시면
          <br /> {getServiceName()} 개발팀이 24시간 이내에
          <br /> 자사몰에 설치를 시작합니다.
        </>
      ),
      index_text_22: "",
      index_text_23: "* 설치 완료 시점부터 이용기간 카운트가 시작됩니다.",
      index_text_24: "결제 진행하기",
      index_text_25: "자사몰 연동 소개 보기",
      _index_text_26: () => (
        <>
          자사몰 연동 절차가 <br />
          궁금하신가요?
        </>
      ),
      index_text_26: `${getServiceName()} 개발팀이 자사몰에 설치`,
      index_text_27: "이용 시작",
      index_text_28: "브랜드가 자사몰에 보여질 포스팅 관리",
      index_text_29: "공개 포스팅만 보기",
      index_text_30: "비공개 포스팅만 보기",
      index_text_31: "포스팅이 없습니다.",
      intro_text_1: "동동이 연동 문의",
      intro_text_2: "오미경",
      intro_text_3: "무신사 스냅과 같은 기능",
      intro_text_4: "이젠 자사몰에 넣어보세요",
      intro_text_5: "자사몰에 포스팅을 연동해 드립니다.",
      intro_text_6: "소개서 다운받기",
      intro_text_7: "제휴문의",
      intro_text_8: "Check Point 1",
      intro_text_9: "왜 자사몰에 집중해야 하냐고요?",
      intro_text_10: `수수료가 없는 자사몰 매출을 `,
      intro_text_11: `끌어올리는 것이 중요합니다.`,
      intro_text_12: "Check Point 2",
      intro_text_13: `고객의 컨텐츠 소비량이 늘어날수록 `,
      intro_text_14: `구매전환율은 올라갑니다`,
      intro_text_15: `양질의 컨텐츠는 고객의 재방문 빈도 및 `,
      intro_text_16: `체류시간을 늘려줍니다.`,
      intro_text_17: "Check Point 3",
      _intro_text_18: () => (
        <>
          대형 플랫폼은 <br className="flex md:hidden" />
          이미 컨텐츠의 중요성을 강조하는 중
        </>
      ),
      _intro_text_19: () => (
        <>
          {`무신사의 "스냅", 크림의 "스타일", `}
          <br className="flex md:hidden" />
          {`지그재그의 "데일리피드"`}
        </>
      ),
      intro_text_20: "너무나도 쉬운 사용법",
      _intro_text_21: () => (
        <>
          {`관리자페이지에서 클릭 한번으로 `}
          <br className="flex md:hidden" />
          {`포스팅을 자사몰에 노출할 수 있습니다.`}
        </>
      ),
      intro_text_22: "다양한 컨텐츠 업로드 가능",
      _intro_text_23: () => (
        <>
          {`갖고 있는 사진 컨텐츠를 직접 올리는 것도, `}
          <br />
          {`유튜브 영상을 올리는 것도 전부 가능합니다.`}
        </>
      ),
      intro_text_24: "담당자를 배정 중입니다...",
      intro_text_25: "담당자 배정이 완료되었습니다.",
      intro_text_26: "오미경 팀장",
      _intro_text_27: (name: any) => (
        <>
          {name} 담당자님, 반갑습니다.
          <br />
          5분 이내로 전화드리겠습니다.
          <br />곧 만나요!
        </>
      ),
      order_postings_text_1: "포스팅 순서 변경하기",
      _order_postings_text_2: () => (
        <>
          포스팅을 클릭해서 끌어다 놓으면 순서를 변경하실 수 있습니다.
          <br />
          공개 포스팅만 보여집니다.
        </>
      ),
      order_postings_text_3: "포스팅이 없습니다.",
      order_postings_text_4: "변경 중입니다",
      order_postings_text_5: "순서변경 완료",
      payments_bills_text_1: "자사몰 연동 설치 비용",
      payments_bills_text_2: "자사몰 연동 이용 비용",
      payments_bills_text_3: "자동결제 취소하기",
      _payments_cancel_complete_text_1: () => (
        <>
          자사몰 연동 이용권
          <br />
          자동 결제가 취소되었습니다.
        </>
      ),
      _payments_cancel_complete_text_2: () => (
        <>
          자사몰 연동 이용권을 다시 구입하고 싶다면,
          <br />
          <b>상단 메뉴[자사몰 연동]</b>을 눌러 이용해주세요.
        </>
      ),
      _payments_cancel_complete_text_3: (date: any) => <>취소 시 {date}일까지 사용이 가능합니다.</>,
      payments_cancel_complete_text_4: "이대로 유지하기",
      payments_cancel_complete_text_5: "자동결제 취소하기",

      payments_complete_text_1: "결제 완료",
      _payments_complete_text_2: (days: number) => (
        <>
          {getServiceName()} 개발팀이 설치를 위해
          <br /> 24시간 이내에 카카오톡으로 연락을 드리겠습니다.
          <br /> (설치시간 약 1일)
          <br />
          <br />
          설치가 완료된 시점부터
          <br />
          이용기간({days}일) 카운트가 시작됩니다.
        </>
      ),
      payments_index_text_1: "결제 내역이 없습니다.",
      payments_index_text_2: "구매 분류",
      show_index_text_1: "원본으로 복구하기",
      show_index_text_2: "크롭한 사진을 원본으로 복구합니다.",
      show_index_text_3: "크롭하기",
      show_index_text_4: "순서 바꾸기"
    },
    inspection_feedback: {
      inspection_overdue_time : `검수 시간이 종료되었습니다.`,
      inspection_overdue_text : `작성하신 내용이 인플루언서에게 즉시 전달됩니다.`,
      inspection_save_button_text : `임시저장하고 나가기`,
      inspection_store_button_text : `검수 완료`,
      inspection_save_modal_title: `임시저장하고 나가시겠어요?`,
      inspection_save_modal_text: `다시 들어와서 수정이 가능하지만,\n그 사이 검수 시간이 종료되면 작성하신 내용이 자동으로\n인플루언서에게 전달됩니다.`,
      inspection_store_modal_decline_feedback_title: `검수를 완료하시겠어요?`,
      inspection_store_modal_decline_feedback_text: `검수를 완료하면 다시 수정 요청을 할 수 없고,${'\n'}작성하신 내용이 인플루언서에게 즉시 전달됩니다.`,
      inspection_store_modal_approve_feedback_title: `피드백 없음으로 전달하시겠어요?`,
      inspection_store_modal_approve_feedback_text: `검수를 완료하면 다시 수정 요청을 할 수 없습니다.`,
      inspection_remain_time : (remainTimeStr) => `${remainTimeStr} 안에 검수하기`,
      inspection_remain_time_2 : (remainTimeStr) => `${remainTimeStr} 남음`,
      inspection_title_completed : `검수 종료`,
      feedback_introduction: `검수는 1회만 가능하며, 인플루언서가 수정 후 글로브 검수팀의 검수를 받은 후 바로 인스타그램에 업로드를 진행합니다.\n재촬영을 제외한 자막, 폰트, 배경음악 등의 수정 요청이 가능합니다.`,
      show_guidelines: `이 캠페인의 가이드라인 보기`,
      inspection_capture_image_title: `특정 장면 캡쳐 후 수정 요청 남기기`,
      inspection_capture_current_sequence : (timestamp)=> `${timestamp} 장면 캡쳐하기`,
      inspection_capture_no_image : `캡쳐한 장면이 없습니다`,
      inspection_feedback_guideline_title : `가이드라인 위반 내역`,
      inspection_feedback_guideline_placeholder : `(예) 비포&애프터 컷을 필수 장면으로 요청했는데, 영상에 들어가있지 않네요.`,
      inspection_feedback_subtitle_font_title : `자막 폰트 변경(영상 전체에 적용)`,
      inspection_feedback_subtitle_font_placeholder : `(예) 영상 전반에 걸쳐 귀여운 폰트를 사용했는데, 가독성이 높은 고딕 계열 폰트로 전부 변경해 주세요.`,
      inspection_feedback_subtitle_size_title : `자막 크기 변경(영상 전체에 적용)`,
      inspection_feedback_subtitle_size_placeholder : `(예) 영상 전반에 걸쳐 자막이 깨알 같은 크기로 들어가 있는데, 가독성이 높아지도록 크기를 전부 1.5배 키워주세요.`,
      inspection_feedback_background_music_title : `배경음악 교체`,
      inspection_feedback_background_music_desc_with_partnership : (
        <>
          파트너십 광고 예정인 캠페인이므로 반드시 저작권 문제가 없는 음원이 삽입되어야 합니다. <br />
          <br />
          만약 지금 보시는 사전 검수용 영상에 배경음악이 들어가있지 않다면, <br />
          인플루언서가 인스타그램에 업로드하면서 음악을 삽입할 확률이 높은데, 이러한 경우 무조건 저작권 문제가 생깁니다. <br />
          <br />
          아래 입력창에 ‘외부 편집 단계에서 음원을 삽입 후 영상을 완성한 뒤 인스타그램에 업로드 해야합니다.’라고 적어주세요.
        </>
      ),
      inspection_feedback_background_music_desc_without_partnership : (
        <>
          인스타그램에 업로드하면서 음악을 삽입하는 경우가 있기 때문에 사전 검수용 파일에는 배경음악이 없을 수도 있습니다.
        </>
      ),
      inspection_feedback_background_music_placeholder : `(예) 유행하는 K-POP 노래를 배경음악으로 사용했는데, 잔잔한 재즈 음악으로 변경해 주세요.`,
      inspection_feedback_guideline_violate : `가이드라인을 위반했어요.`,
      inspection_feedback_narration_add_title : `나레이션 추가`,
      inspection_feedback_narration_add_desc : `나레이션 추가는 재촬영 범주에 포함되므로 가이드라인을 위반한 경우가 아니라면 요청하실 수 없습니다.`,
      inspection_feedback_narration_add_placeholder : `나레이션 관련 가이드라인 위반 내용 및 요청사항 입력`,
      inspection_feedback_narration_edit_title : `나레이션 수정`,
      inspection_feedback_narration_edit_desc : `나레이션 수정은 재촬영 범주에 포함되므로 가이드라인을 위반한 경우가 아니라면 요청하실 수 없습니다.`,
      inspection_feedback_narration_edit_placeholder : `나레이션 관련 가이드라인 위반 내용 및 요청사항 입력`,
      inspection_feedback_narration_delete_title : `나레이션 삭제`,
      inspection_feedback_narration_delete_desc : `삭제하고자 하는 나레이션이 포함된 장면을 캡쳐하여 해당 장면에 요청을 남겨주세요.`,
    }
  },
  guidelineTitles:{
    PHOTO_MODEL_FULL: '제품 착용샷 - 정면으로 서서 (머리, 발끝 잘리지 않게)',
    PHOTO_MODEL_HALF: '제품 착용샷 - 반신샷',
    PHOTO_MODEL_CLOSEUP: '제품 착용샷 - 제품 디테일 클로즈업',
    PHOTO_PRODUCT_FULL: '제품 단독샷 - 제품 전체샷',
    PHOTO_PRODUCT_CLOSEUP: '제품 단독샷 - 제품 디테일 클로즈업',
  },
}

export default ko
